//引入外部模組
import {checkDevice} from '@/common';
import {LazyLoad} from '@/lazyload';


//Lightbox
class LightboxMap {
  constructor() {
    this.map = '#mapCanvas';

    //台灣圖霸api key
    this.gompAccessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM';
    //
  }
  
  //API
  initialize(mapInfo) {
    
    //Lat & Lng
    const lat      = mapInfo.lat;
    const lng      = mapInfo.lng;
    // const myLatLng = new google.maps.LatLng(lat, lng);
    const myLatLng = [ lng, lat ];
    var center = {
        lat: lat,
        lng: lng
    };

    gomp.accessToken = this.gompAccessToken;
    /*
    
    gomp.accessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM';
    */
    //ab -n 100 -c 100 -k http://www.futurelove.com.tw/
    //地圖基本設定
    var mapOptions = {
      container: 'mapCanvas', // 地圖容器 ID
      // style: 'https://api.map8.zone/styles/go-life-maps-tw-style-std/style.json', // 地圖樣式檔案位置
      style: 'https://api.map8.zone/styles/go-life-maps-tw-style-singfujia-0e0150b5/style.json',
      maxBounds: [[105, 15], [138.45858, 33.4]], // 台灣地圖區域
      // maxBounds: [[center.lng - boundsRange.lng, center.lat - boundsRange.lat], [center.lng + boundsRange.lng, center.lat + boundsRange.lat]],
      center: [ lng, lat], // 初始中心座標，格式為 [lng, lat]
      // center: [120.221420, 23.008305], // 初始中心座標，格式為 [lng, lat]
      zoom: 15, // 初始 ZOOM LEVEL; [0-20, 0 為最小 (遠), 20 ;最大 (近)]
      minZoom: 6, // 限制地圖可縮放之最小等級, 可省略, [0-19.99]
      maxZoom: 19.99, // 限制地圖可縮放之最大等級, 可省略 [0-19.99]
      pitch: 0, // 攝影機仰角, 可省略, [0-60]
      bearing: 0, // 地圖角度, 可省略, [-180 ~ 180; 0 為正北朝上, 180 為正南朝上]
      attributionControl: false,
      speedLoad: false
    };

    //繪製地圖
    var map = new gomp.Map(mapOptions).addControl(new gomp.AttributionControl({
      compact: false
    }));

    //主標記 & 資訊窗
    this.mapMarker(myLatLng, map, mapInfo);

  } //initialize(mapInfo) {

  //主標記 & 資訊窗
  mapMarker(myLatLng, map, mapInfo) {

    //設定地圖標記點
    var markerEl = document.createElement('img');
    markerEl.src = './images/marker.png'; // 請代換為您的圖檔之 URL (例如 "https://example.com/image.png")
    markerEl.style = 'width:80px;';

    //建立地圖標記點
    map.on('load', function () {
      var nowMapCenterPoint = map.getCenter();
      /*
      var markerPoint = new gomp.Marker(markerEl, {offset: [0, -21]})
          .setLngLat(nowMapCenterPoint)
          .addTo(map);

      */
      map.addImage('marker', markerEl);//加入圖
      map.addLayer(pointsSource); //加入訊息框的layer

      //移除map8 logo
      $('.gomp-ctrl-bottom-right').remove();
    });

    //---建立物件資料訊息框 start
    
    var pointsSource = {
        "id": "pois",
        "type": "symbol",
        "source": {
            "type": "geojson",
            "data": {
                "type": "FeatureCollection",
                "features": [{
                    "type": "Feature",
                    "properties": {
                      "description": '<h3>' + mapInfo.title + '</h3><p class="add">' + mapInfo.add + '</p><p class="option">' + mapInfo.option + '</p>',
                    },
                    "geometry": {
                        "type": "Point",
                        "coordinates": [mapInfo.lng, mapInfo.lat]
                    }
                }]
            }
        },
        "layout": {
                "icon-image": "marker",
                "icon-offset": [0, -12],
                "icon-allow-overlap": true,
                "icon-size": 0.3
        }
    } //var pointsSource = {

    var popup = new gomp.Popup({
        anchor: 'bottom',
        closeButton: true,
        closeOnClick: false,
        offset: [0, -42]
    });

    map.on('click', 'pois', function(e) {
        // 設定滑鼠游標樣式
        map.getCanvas().style.cursor = 'pointer';

        var coordinates = e.features[0].geometry.coordinates.slice();
         var description = e.features[0].properties.description;

        // 確保訊息視窗不會被遮擋
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        // 設定訊息視窗內容並在地圖上顯示
        popup.setLngLat(coordinates)
            .setHTML(description)
            .addTo(map);
    });
    //---建立物件資料訊息框 end
    
  } //mapMarker(myLatLng, map, mapInfo) {
  
  //輸出
  mapAPI() {
    const map = $(this.map);
    const mapInfo = {
      el    : this.map,
      lat   : map.data('lat'),
      lng   : map.data('lng'),
      title : map.data('title'),
      add   : map.data('add'),
      option: map.data('option')
    };

    this.initialize(mapInfo);

    //移除map8 logo
    $('.gomp-ctrl-bottom-right').remove();
    $('.gomp-ctrl-bottom-left').remove();
    
  }
}



//物件內頁-週邊地圖
class MapRealtyDetail {
  
  constructor() {
    this.map = '#mapCanvasInside';
    // this.rd  = $('.googleMap');
    this.rd  = $('.map8');
    // this.rd  = $('#map8_content');
    this.nav = this.rd.data('nav'); //頁面key判斷(nav = buy_d)
    this.mt  = this.rd.data('mt'); //項目名稱 realty_d
    this.id  = this.rd.data('id'); //物件id  
    //偏移距離
    this.boundsRange = {
        // lat: 0.013, 
        // lng: 0.022
        lat: 0.001, 
        lng: 0.001
    }
  }

  //API 定義基本參數，及宣告其它function
  initialize(mapInfo) {

    //Lat & Lng
    const lat = mapInfo.lat;
    const lng = mapInfo.lng;
    const myLatLng = [ lng, lat ];
    var center = {
        lat: lat, 
        lng: lng
    };
    

    //台灣圖霸api key
    
    gomp.accessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM';
    

    //地圖基本設定
    var mapOptions = {
      container: 'mapCanvasInside', // 地圖容器 ID
      // style: 'https://api.map8.zone/styles/go-life-maps-tw-style-std/style.json', // 地圖樣式檔案位置
      style: 'https://api.map8.zone/styles/go-life-maps-tw-style-singfujia-0e0150b5/style.json',
      maxBounds: [[105, 15], [138.45858, 33.4]], // 台灣地圖區域
      // maxBounds: [[center.lng - boundsRange.lng, center.lat - boundsRange.lat], [center.lng + boundsRange.lng, center.lat + boundsRange.lat]],
      center: [ lng-this.boundsRange.lng, lat-this.boundsRange.lat], // 初始中心座標，格式為 [lng, lat]
      // center: [120.221420, 23.008305], // 初始中心座標，格式為 [lng, lat]
      zoom: 15, // 初始 ZOOM LEVEL; [0-20, 0 為最小 (遠), 20 ;最大 (近)]
      minZoom: 6, // 限制地圖可縮放之最小等級, 可省略, [0-19.99]
      maxZoom: 19.99, // 限制地圖可縮放之最大等級, 可省略 [0-19.99]
      pitch: 0, // 攝影機仰角, 可省略, [0-60]
      bearing: 0, // 地圖角度, 可省略, [-180 ~ 180; 0 為正北朝上, 180 為正南朝上]
      attributionControl: false,
      speedLoad: false
    };

    //繪製地圖
    var map = new gomp.Map(mapOptions).addControl(new gomp.AttributionControl({
      compact: false
    }));

    //將基本設定戴入到地圖
    map.addControl(new gomp.FullscreenControl({container: document.querySelector('.map8')})); //放大全螢幕功能
    map.addControl(new gomp.NavigationControl(), 'top-left'); //週邊地圖拉遠拉進設定加入

    //移除map8 logo
    $('.gomp-ctrl-bottom-right').remove();
    

    //全螢幕放大
    /*
    $('.gomp-ctrl-fullscreen').on('click', function() {
      $('.gomp-canvas').width('100%');
    });
    */ 

    //---建立物件資料訊息框 start
    
    var pointsSource = {
        "id": "pois",
        "type": "symbol",
        "source": {
            "type": "geojson",
            "data": {
                "type": "FeatureCollection",
                "features": [{
                    "type": "Feature",
                    "properties": {
                        "description": "<span style='font-weight:bold;font-size:16px;'>"+mapInfo.title+"</span><br /><span>"+mapInfo.add+"</span>",
                    },
                    "geometry": {
                        "type": "Point",
                        "coordinates": [lng-this.boundsRange.lng, lat-this.boundsRange.lng]
                    }
                }]
            }
        },
        "layout": {
                "icon-image": "marker",
                "icon-offset": [0, -12],
                "icon-allow-overlap": true,
                "icon-size": 0.3
        }
    } //var pointsSource = {
    var popup = new gomp.Popup({
        anchor: 'bottom',
        closeButton: true,
        closeOnClick: false,
        offset: [0, -42]
    });

    map.on('click', 'pois', function(e) {
        // 設定滑鼠游標樣式
        map.getCanvas().style.cursor = 'pointer';

        var coordinates = e.features[0].geometry.coordinates.slice();
        var description = e.features[0].properties.description;

        // 確保訊息視窗不會被遮擋
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        // 設定訊息視窗內容並在地圖上顯示
        popup.setLngLat(coordinates)
            .setHTML(description)
            .addTo(map);
    });         
    
    //---建立物件資料訊息框 end 

    
    //設定地圖標記點
    var markerEl = document.createElement('img');
    markerEl.src = './images/marker.png'; // 請代換為您的圖檔之 URL (例如 "https://example.com/image.png")
    markerEl.style = 'width:80px;';

    //建立地圖標記點
    map.on('load', function () {
      var nowMapCenterPoint = map.getCenter();
      /*
      var markerPoint = new gomp.Marker(markerEl, {offset: [0, -21]})
          .setLngLat(nowMapCenterPoint)
          .addTo(map);
      */
      map.addImage('marker', markerEl);//加入圖
      map.addLayer(pointsSource); //加入訊息框的layer
    });
    

    //主標記 & 資訊窗
    // this.mapMarker(myLatLng, map, mapInfo);

    //---周邊設施參數宣告(map8)
    //將基本設定戴入到地圖
    // var gompWebServiceJsClient = new GompWebServiceJsClient({key: gomp.accessToken});

    
    // var radius = 500;    // 500 公尺
    // var colorIndex = {blue: "#2970C0", green: "#4E9A54", gold: "#D28706", red: "#D63030"};
    var iconArray = ["airport", "bank", "bus", "edu", "gas", "hospital", "office", "park", "parking", "store", "subway", "temple", "train", "conv", "funeral", "trash", "people", "factory"];
    var iconElArray = {};
    
    //地標圖設定
    iconArray.forEach(function(iconName) { 
        var el = document.createElement("img");
        el.src = "images/icons/" + iconName + ".png";
        iconElArray[iconName] = el;
    });

    // console.log('開始mapAround');
    this.mapAround(mapInfo, map); //週邊環境(中心點、地圖參數)
    this.tab_click(mapInfo, map); //點擊周邊環境時觸發，代入物件資料(主要用坐標)，回傳週邊地圖陣列

    //主標記 & 資訊窗
    // this.mapMarker(myLatLng, map, infoWindow, mapInfo);

    // map.addLayer(reData); //代入回傳週邊地圖資料陣列
  } //initialize(mapInfo) {
  
  
  
  /******************週邊環境選擇 tab 按下時 start********************/
  //依中心點，並依點擊的設施，列出相關地標資料並回傳為陣列
  tab_click(mapInfo, map) {

    //---回原點(判斷是否有定位)
    $('#backBtn').on('click', () => {
      map.flyTo({
        center: [mapInfo.lng-this.boundsRange.lng, mapInfo.lat-this.boundsRange.lat], // 中心點
        zoom: 15, // 縮放比例
        // pitch: 45 // 頃斜度
      })

    });

    //---選取週邊設施項目(列表項目)
    $("#nearby_amenity li").click(function(){
      // var catValue      = $(this).attr('data-cat');
      // var iconValue     = $(this).find('button').attr('data-type');
      var catValue      = $("#nearby_amenity li").find('button[class="actives"]').parents().attr('data-cat');
      var iconValue     = $("#nearby_amenity li").find('button[class="actives"]').attr('data-type');
      var distanceValue = $('.distanceTabs li').find('button[class="actives"]').attr('data-distance');
      
      //判斷學區圖
      // if( iconValue == 'school_district_es') {
      //   //國小
      //   toggleSchoolDistLayers('school_district_es');
      // } else if( iconValue == 'school_district_jhs' ) {
      //   //國中
      //   toggleSchoolDistLayers('school_district_jhs');
      // } else if( iconValue == 'hideAll' ) {
      //   //不顯示學區
      //   toggleSchoolDistLayers('hideAll');  
      // } else {
        //判斷是否有值，有值再標示週邊
        if(catValue == undefined || iconValue == undefined || distanceValue == undefined ) {
          //沒值則切換為清空
          removeMapAround(map, iconValue);
        } else {
          if( catValue.length != 0 && iconValue.length != 0 && distanceValue.length != 0) {
            //皆有值則切換
            MapAroundDisplay(catValue, iconValue, distanceValue);
          }
        }
        /*
        if( catValue.length != 0 && iconValue.length != 0 && distanceValue.length != 0) {
          //皆有值則切換
          console.log('切換');
          MapAroundDisplay(catValue, iconValue, distanceValue);
        } 
        */
      // } //if( iconValue == 'school_district_es') {
        
      
      // MapAround(catValue, iconValue, distanceValue);
    });

    
    //---選取距離(列表公里)
    $('.distanceTabs li').click(function(){
      var catValue      = $("#nearby_amenity li").find('button[class="actives"]').parents().attr('data-cat');
      var iconValue     = $("#nearby_amenity li").find('button[class="actives"]').attr('data-type');
      var distanceValue = $('.distanceTabs li').find('button[class="actives"]').attr('data-distance');

      //判斷是否有值，有值再標示週邊
      if(catValue == undefined || iconValue == undefined || distanceValue == undefined ) {
        removeMapAround(map, iconValue);
      } else {
        if( catValue.length != 0 && iconValue.length != 0 && distanceValue.length != 0) {
          //皆有值則切換
          MapAroundDisplay(catValue, iconValue, distanceValue);
        }
      }
      /*
      if( catValue.length != 0 && iconValue.length != 0 && distanceValue.length != 0) {
        //皆有值則切換
        MapAroundDisplay(catValue, iconValue, distanceValue);
      } 
      */
    }); //$('.distanceTabs li').click(function(){

    //---預設選取第一筆資料
    map.on('load', function () {
      var catValue      = $("#nearby_amenity li").find('button[class="actives"]').parents().attr('data-cat');
      var iconValue     = $("#nearby_amenity li").find('button[class="actives"]').attr('data-type');
      var distanceValue = $('.distanceTabs li').find('button[class="actives"]').attr('data-distance');
      if( catValue.length != 0 && iconValue.length != 0 && distanceValue.length != 0) {
        MapAroundDisplay(catValue, iconValue, distanceValue);
      }
    });

    /********************點地圖坐標顯示訊息框*********************/
    let setPopup = (feature, distance) => { 

      //訊息匡參數
        var popup = new gomp.Popup({
          anchor: 'bottom',
          closeButton: true,
          closeOnClick: false,
          autoPan: true,
          offset: [0, -12],
          className: 'my-class'
        });

        // var distance = gompWebServiceJsClient.getDistanceFromLatLngInKm(center.lat, center.lng, feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
        popup
            .setLngLat(feature.geometry.coordinates)
            .setHTML(
                '<h5 style="font-size: 1.25em;font-weight: bold;">' + feature['properties']['name'] + '</h5>' +
  
                // [Jethro 2019-09-91] Port to Map8's Premium / Housing API
                ((feature["properties"]["formatted_address"].length !== 0) ? '<span class="badge">景點地址</span>' + feature["properties"]["formatted_address"] + '<br />' : '') +
  
                '<span class="badge">直線距離</span>' + distance + ' 公尺<br />'
            )
            .addTo(map);
        popup.id = feature.properties.id;
  
        // 移至 Popup 可見範圍
        var dPWidth = popup._container.offsetWidth;
        var dPHeight = popup._container.offsetHeight;
        var dPX = popup._pos.x;
        var dPY = popup._pos.y;
        var mapW = map.transform.width;
        var mapH = map.transform.height;
        var padding = 20;
        var panPoint = {
            x: 0,
            y: 0
        };
        if (dPX < dPWidth / 2 + padding) {
            panPoint.x = dPX - (dPWidth / 2 + padding);
        }
        if (dPX > mapW - padding - dPWidth / 2) {
            panPoint.x = dPX - (mapW - dPWidth / 2 - padding);
        }
        if (dPY < dPHeight + padding + 53) {
            panPoint.y = dPY - (dPHeight + padding + 53);
        }
        if (dPY > mapH - padding) {
            panPoint.y = dPY - (mapH - padding);
        }
        map.panBy([panPoint.x, panPoint.y]);
    }

    
    /******************刪除週邊相關資料********************/
    let removeMapAround = (map, iconValue) => {
      //週邊環境移除
      if( map.getLayer("nearby_amenity-style") ) {
        map.removeLayer("nearby_amenity-style"); //清除圖標
        map.removeSource("nearby_amenity"); //清除資料陣列
      } //if( map.getLayer("nearby_amenity-style") ) {
        
      //檢查是否已經有此圖像
      if(iconValue != undefined) {
        if( map.hasImage( iconValue ) ) {
          map.removeImage( iconValue );
        }
      } //if(iconValue != undefined) {
      
      //全刪掉訊息框資料
      // console.log('圖層數量:'+ $('.gomp-popup .gomp-popup-anchor-bottom').length );
      $('.gomp-popup').remove();

      

      //移除畫圓資料
      // if( map.getLayer("circle-outline") && map.getLayer("circle-text") && map.getLayer("circle-fill") ) {
      if( map.getLayer("circle-outline") ) {  
        
        map.removeLayer("circle-outline");  //外圍線
        map.removeSource("circle-outline"); //清除資料陣列

        map.removeLayer("circle-text"); //字
        map.removeSource("circle-text"); //清除資料陣列

        map.removeLayer("circle-fill"); //底色
        map.removeSource("circle-fill"); //清除資料陣列

      } //if( map.getLayer("circle-outline") ) {  

      //移除範圍資料(列表式)
      $('.place').html(' ');
    } // removeMapAround(map, iconValue) {

   /******************週邊環境選擇 tab 按下時 end********************/

    // $("#nearby_amenity li").click(function(){
    let MapAroundDisplay = (catValue, iconValue, distanceValue) => { 

      this.removeMapAround(map, iconValue);
      
      //週邊環境移除
      /*
      if( map.getLayer("nearby_amenity-style") ) {
        map.removeLayer("nearby_amenity-style"); //清除圖標
        map.removeSource("nearby_amenity"); //清除資料陣列
      } //if( map.getLayer("nearby_amenity-style") ) {

      //檢查是否已經有此圖像
      if( map.hasImage( iconValue ) ) {
        map.removeImage( iconValue );
      }

      //全刪掉訊息框資料
      // console.log('圖層數量:'+ $('.gomp-popup .gomp-popup-anchor-bottom').length );
      // $('.gomp-popup').remove();


      //移除畫圓資料
      // if( map.getLayer("circle-outline") && map.getLayer("circle-text") && map.getLayer("circle-fill") ) {
      if( map.getLayer("circle-outline") ) {  

        map.removeLayer("circle-outline");  //外圍線
        map.removeSource("circle-outline"); //清除資料陣列

        map.removeLayer("circle-text"); //字
        map.removeSource("circle-text"); //清除資料陣列

        map.removeLayer("circle-fill"); //底色
        map.removeSource("circle-fill"); //清除資料陣列

      } //if( map.getLayer("circle-outline") ) {  

      //移除範圍資料(列表式)
      $('.place').html(' ');
      */
      
      //抓取範圍
      // var distanceValue = $('.distanceTabs li').find('button[class="active"]').attr('data-distance');

      //抓取所點擊設施的參數
      // var catValue = $(this).attr('data-cat'); //中文(用到搜尋資料用)
      // var iconValue = $(this).find('button').attr('data-type'); //英文代號(用到icon上)
      var radiusValue = distanceValue/1000; //抓資料範圍
      var colorIndex = {blue: "#2970C0", green: "#4E9A54", gold: "#D28706", red: "#D63030"};

      //map8的key值

      gomp.accessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM';

      //將參數傳進map8抓取坐標資料
      //傳送進 https://api.map8.zone/v2/premium/housing/nearbyNimby 抓取回傳周邊坐標
      var key_url = 'https://api.map8.zone/v2/premium/housing/nearbyAmenity?key='+gomp.accessToken+'&location='+mapInfo.lat+'%2C'+mapInfo.lng+'&radius='+radiusValue+'&cat='+catValue;

      // console.log(key_url);
      //&limit=10
      var gompWebServiceJsClient = new GompWebServiceJsClient({key: gomp.accessToken});
      var reData; //週邊地圖結果回傳

      $.ajax({
          url: key_url,
          dataType: 'json',
          async: false //非同步處理
        }).done(function( data ) {
          // console.log(data);
          //篩選陣列內容
          reData = data.results.filter(function(item, index, array){
            // console.log(item.cat+"---"+catValue);s
            return item.cat == catValue; 
            // return item.cat.localeCompare(catValue); 
        }); //done(function( data ) {
      }); //$.ajax({

      // console.log(reData);

      //重新安排陣列
      var Arr = []; //預計紀錄的陣列
      reData.map(function(n) {
        var geoJ = {
            "type":"Feature",
            "geometry":{
              "type":"Point",
              "coordinates":[
                n.geometry.location.lng,
                n.geometry.location.lat
              ]
            },
            "properties": n
        };
        Arr.push(geoJ); 
      });


      //周邊設施重排陣列
      var mapString = {
          "type":"FeatureCollection",
          "features":Arr
      };

      
      var popup = new gomp.Popup({
        anchor: 'bottom',
        closeButton: true,
        closeOnClick: false,
        autoPan: true,
        offset: [0, -42],
        className: 'my-class'
      });

      //---把值放入到map8地圖

      //設定對應圖
      var ele = document.createElement("img");
      ele.src = "images/icons/" + iconValue + ".png";
      
      var icon_array = {};
      icon_array[0] = ele;
      // console.log(icon_array[0]);

      map.addImage(iconValue, icon_array[0]);
      //map.addImage('markerK', map_ele_obj_icon['K']);
      // console.log('圖片載入完畢');
      // console.log(mapString);
      //重新寫入的程式
      
      map.addSource(
        "nearby_amenity", 
        {
            "type": "geojson",
            "data": mapString
        }
      );

      /*
      map.setLayoutProperty(
        'amenityLayer',
          // 'twhg-stores',
            {
                "stops": [
                  //  zoom level 14 以上才會顯示，故設定 12
                    [12, ""], // zoom level 12 - 18 皆顯示空字串
                    [14, "{NAME}"], // zoom level 18 起才顯示名稱
                ]
            }
      )
      */
      
      //重新加入的圖層
      map.addLayer({
          id: "nearby_amenity-style",
          type: "symbol",
          source: "nearby_amenity",
          layout: {
              "icon-image": iconValue,
              "icon-allow-overlap": true
          },
          paint: {
              "icon-opacity": 1
          }
      });

      
      // 訊息圖層
      map.on("mouseenter", 'nearby_amenity-style', function() {
          map.getCanvas().style.cursor = "pointer";
      });
      map.on("mouseleave", 'nearby_amenity-style', function() {
          map.getCanvas().style.cursor = "";
      });

      var countvv = 0;
      map.off("click").on("click", 'nearby_amenity-style', function(e) {
        // map.bind("click", 'nearby_amenity-style', function(e) {
        // console.log(e);
          // countvv++;

          // console.log('點擊nearby_amenity-style次數:'+countvv);

          var feature = e.features[0]; //參數
          var distance = gompWebServiceJsClient.getDistanceFromLatLngInKm(mapInfo.lat, mapInfo.lng, feature.geometry.coordinates[1], feature.geometry.coordinates[0]); //距離

          setPopup(feature, distance);
          //---將setPopup內容直接移過來
          /*
          var distance = gompWebServiceJsClient.getDistanceFromLatLngInKm(mapInfo.lat, mapInfo.lng, feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
          // console.log(feature.geometry.coordinates);
          popup
              .setLngLat(feature.geometry.coordinates)
              .setHTML(
                  '<h5 style="font-size: 1.25em;font-weight: bold;">' + feature['properties']['name'] + '</h5>' +

                  // [Jethro 2019-09-91] Port to Map8's Premium / Housing API
                  ((feature["properties"]["formatted_address"].length !== 0) ? '<span class="badge">景點地址</span>' + feature["properties"]["formatted_address"] + '<br />' : '') +

                  '<span class="badge">直線距離</span>' + distance + ' 公尺<br />'
              )
              .addTo(map);
              // console.log(distance);
          popup.id = feature.properties.id;

          // 移至 Popup 可見範圍
          var dPWidth = popup._container.offsetWidth;
          var dPHeight = popup._container.offsetHeight;
          var dPX = popup._pos.x;
          var dPY = popup._pos.y;
          var mapW = map.transform.width;
          var mapH = map.transform.height;
          var padding = 20;
          var panPoint = {
              x: 0,
              y: 0
          };
          if (dPX < dPWidth / 2 + padding) {
              panPoint.x = dPX - (dPWidth / 2 + padding);
          }
          if (dPX > mapW - padding - dPWidth / 2) {
              panPoint.x = dPX - (mapW - dPWidth / 2 - padding);
          }
          if (dPY < dPHeight + padding + 53) {
              panPoint.y = dPY - (dPHeight + padding + 53);
          }
          if (dPY > mapH - padding) {
              panPoint.y = dPY - (mapH - padding);
          }
          map.panBy([panPoint.x, panPoint.y]);
          */
          //---將setPopup內容直接移過來
      });

      // 繪製中心點半徑方圓範圍
      // var circle = turf.circle(turf.point([mapInfo.lng, mapInfo.lat]), radius / 1000, {});

      var circle = turf.circle(turf.point([mapInfo.lng-this.boundsRange.lng, mapInfo.lat-this.boundsRange.lat]), radiusValue, {});
      
      map.addLayer({
          "id": "circle-fill",
          "type": "fill",
          "source": {
              "type": "geojson",
              "data": circle
          },
          "paint": {
              "fill-color": colorIndex["blue"],
              "fill-opacity": 0.2
          }
      });
      
      map.addLayer(
          {
              id: "circle-text",
              type: "symbol",
              source: {
                  type: "geojson",
                  data: {
                      type: "FeatureCollection",
                      features: [
                          {
                              type: "Feature",
                              geometry: {
                                  type: "Point",
                                  coordinates: [mapInfo.lng-this.boundsRange.lng, mapInfo.lat-this.boundsRange.lat]
                              }
                          }
                      ]
                  }
              },
              layout: {
                  'text-allow-overlap': true,
                  'text-field': '半徑 '+ distanceValue +' 公尺範圍',
                  'text-font': ["Open Sans Regular"],
                  'text-offset': [0, 1],
                  'text-size': 15
              },
              paint: {
                  'text-color': colorIndex["blue"],
                  'text-halo-color': '#fff',
                  'text-halo-width': 2
              }
          }
      );
      map.addLayer({
          "id": "circle-outline",
          "type": "line",
          "source": {
              "type": "geojson",
              "data": circle
          },
          "paint": {
              "line-color": "blue",
              "line-opacity": 0.3,
              "line-width": 2,
              "line-offset": 1
          },
          "layout": {
          }
      });

      //週邊地圖資料，放置列表
      reData.forEach(function(item, index, array){
        $('.place').append('<li class="mapAroundList"><p class="name" lng="'+item.geometry.location.lng+'" lat="'+item.geometry.location.lat+'" add="'+item.formatted_address+'" distance="'+(item.distance*1000)+'">' + item.name + '</p><p class="distance">約<span>' + (item.distance*1000)+ '</span>公尺</p></li>');
      });

      //資料列表點擊觸發
      $('.mapAroundList').on("click", function(e) {
        //  console.log($(this).find('p').attr('data'));
        //  console.log(popup);
        const add = $(this).find('p').attr('add');
        const lng = $(this).find('p').attr('lng');
        const lat = $(this).find('p').attr('lat');
        const object_name = $(this).find('p').html();
        const distance = $(this).find('p').attr('distance');
        
        popup
        .setLngLat([lng,lat])
        .setHTML(
            '<h5 style="font-size: 1.25em;font-weight: bold;">' + object_name + '</h5>' +

            // [Jethro 2019-09-91] Port to Map8's Premium / Housing API
            ((add.length !== 0) ? '<span class="badge">景點地址</span>' + add + '<br />' : '') +

            '<span class="badge">直線距離</span>' + distance + ' 公尺<br />'
        )
        .addTo(map);
        
        
        // 移至 Popup 可見範圍
        var dPWidth = popup._container.offsetWidth;
        var dPHeight = popup._container.offsetHeight;
        var dPX = popup._pos.x;
        var dPY = popup._pos.y;
        var mapW = map.transform.width;
        var mapH = map.transform.height;
        var padding = 20;
        var panPoint = {
            x: 0,
            y: 0
        };
        if (dPX < dPWidth / 2 + padding) {
            panPoint.x = dPX - (dPWidth / 2 + padding);
        }
        if (dPX > mapW - padding - dPWidth / 2) {
            panPoint.x = dPX - (mapW - dPWidth / 2 - padding);
        }
        if (dPY < dPHeight + padding + 53) {
            panPoint.y = dPY - (dPHeight + padding + 53);
        }
        if (dPY > mapH - padding) {
            panPoint.y = dPY - (mapH - padding);
        }
        map.panBy([panPoint.x, panPoint.y]);
        
      });

    // }); // $("#nearby_amenity li").click(function(){
    } //let MapAroundDisplay = (catValue, iconValue, distanceValue) => { 

    

    /******************學區圖用 start********************/
    var schoolDistType = ["school_district_es", "school_district_jhs"];
    map.once("idle", function() {
        map.addSource("school_dist", {
            type: "vector",
            url: "https://api.map8.zone/data/school-district.json"
        });
        schoolDistType.forEach(function(name, i) {
            map.addLayer({
                'id': name,
                'type': "fill",
                'source': "school_dist",
                'source-layer': name,
                'paint': {
    
                    'fill-color': '#000000',
                    'fill-opacity': 0.7
                },
                'layout': {
                    'visibility': 'none'
                }
            });
            map.addLayer({
                'id': name + '_line_black',
                'type': "line",
                'source': "school_dist",
                'source-layer': name,
                'paint': {
                    'line-color': (name == 'school_district_es') ? '#666' : '#333',
                    'line-opacity': 1,
                    'line-width': 0.5
                },
                'layout': {
                    'line-join': 'miter',
                    'visibility': 'none'
                }
            });
            map.addLayer({
                'id': name + '_line',
                'type': "line",
                'source': "school_dist",
                'source-layer': name,
                'paint': {
                    'line-color': (name == 'school_district_es') ? '#ffff00' : '#ff6f00',
                    'line-opacity': 1,
                    'line-width': 3
                },
                'layout': {
                    'line-join': 'miter',
                    'visibility': 'none'
                }
            }, name + '_line_black');
            map.addLayer({
                'id': name + '_text',
                'type': "symbol",
                'source': "school_dist",
                'source-layer': name,
                'layout': {
                    'text-field': [
                        'format',
                        ['get', 'schoolname'], {},
                        '\n ', {},
                        '學區', {'font-scale': .8},
                    ],
                    'text-font': ["Open Sans Bold"],
                    'text-size': 15,
                    'visibility': 'none'
                },
                'paint': {
                    'text-color': (name == 'school_district_es') ? '#ffff00' : '#fc7c21',
                    'text-halo-color': '#000',
                    'text-halo-width': 1
                }
            });
        }); 
    }); //map.once("idle", function() {

    //畫圖線(學區圖)
    let setSchoolDistLayerVisibility = (schoolDistType, visibility) => { 
      var layerNameSuffixes = ['', '_line', '_line_black', '_text'];
      layerNameSuffixes.forEach(function(v) {
          map.setLayoutProperty(schoolDistType + v, "visibility", visibility);
      }); 
    } //let setSchoolDistLayerVisibility = (schoolDistType, visibility) => {

    //判斷學區圖
    let toggleSchoolDistLayers = (target) => { 
      if (target == schoolDistType[0]) {
        setSchoolDistLayerVisibility(schoolDistType[0], 'visible');
        setSchoolDistLayerVisibility(schoolDistType[1], 'none');
      } else if (target == schoolDistType[1]) {
          setSchoolDistLayerVisibility(schoolDistType[0], 'none');
          setSchoolDistLayerVisibility(schoolDistType[1], 'visible');
      } else {
        //不顯示
        setSchoolDistLayerVisibility(schoolDistType[0], 'none');
        setSchoolDistLayerVisibility(schoolDistType[1], 'none');
      }
    } //let toggleSchoolDistLayers= (target) => { 

    $(".school_distance").click(function(){
        var iconValue     = $(this).attr('data-info'); //抓取學區圖的顯示狀態

        //判斷學區圖
        if( iconValue == 'school_district_es') {
          //國小
          toggleSchoolDistLayers('school_district_es');
        } else if( iconValue == 'school_district_jhs' ) {
          //國中
          toggleSchoolDistLayers('school_district_jhs');
        // } else if( iconValue == 'hideAll' ) {
        //   //不顯示學區
        //   toggleSchoolDistLayers('hideAll');
        } else {
          toggleSchoolDistLayers('hideAll');
        } //if( iconValue == 'school_district_es') {
        
        // MapAround(catValue, iconValue, distanceValue);
      });

  } //tab_click(mapInfo) {

  /******************學區圖用 end ********************/


  /******************刪除週邊相關資料********************/
  removeMapAround(map, iconValue) {
    //週邊環境移除
    if( map.getLayer("nearby_amenity-style") ) {
      map.removeLayer("nearby_amenity-style"); //清除圖標
      map.removeSource("nearby_amenity"); //清除資料陣列
    } //if( map.getLayer("nearby_amenity-style") ) {

    //檢查是否已經有此圖像
    if( map.hasImage( iconValue ) ) {
      map.removeImage( iconValue );
    }

    //全刪掉訊息框資料
    // console.log('圖層數量:'+ $('.gomp-popup .gomp-popup-anchor-bottom').length );
    $('.gomp-popup').remove();


    //移除畫圓資料
    // if( map.getLayer("circle-outline") && map.getLayer("circle-text") && map.getLayer("circle-fill") ) {
    if( map.getLayer("circle-outline") ) {  
      
      map.removeLayer("circle-outline");  //外圍線
      map.removeSource("circle-outline"); //清除資料陣列

      map.removeLayer("circle-text"); //字
      map.removeSource("circle-text"); //清除資料陣列

      map.removeLayer("circle-fill"); //底色
      map.removeSource("circle-fill"); //清除資料陣列

    } //if( map.getLayer("circle-outline") ) {  

    //移除範圍資料(列表式)
    $('.place').html(' ');
  } // removeMapAround(map, iconValue) {

  /******************週邊環境選擇 tab 按下時 end********************/

  //主標記 & 資訊窗
  // mapMarker(myLatLng, map, infoWindow, mapInfo) {
  mapMarker(myLatLng, map, mapInfo) {  

    //設定訊息框內容
    var pointsSource = {
      "id": "pois",
      "type": "symbol",
      "source": {
          "type": "geojson",
          "data": {
              "type": "FeatureCollection",
              "features": [{
                  "type": "Feature",
                  "properties": {
                      "description": "<span style='font-weight:bold;font-size:16px;'>"+mapInfo.title+"</span><br /><span>"+mapInfo.add+"</span>",
                  },
                  "geometry": {
                      "type": "Point",
                      "coordinates": [mapInfo.lng, mapInfo.lat]
                  }
              }]
          }
      },
      "layout": {
              "icon-image": "marker",
              "icon-offset": [0, -12],
              "icon-allow-overlap": true
      }
    } //var pointsSource = {

    var popup = new gomp.Popup({
        anchor: 'bottom',
        closeButton: true,
        closeOnClick: false,
        offset: [0, -42]
    });

    map.on('click', 'pois', function(e) {
      // 設定滑鼠游標樣式
      map.getCanvas().style.cursor = 'pointer';

      var coordinates = e.features[0].geometry.coordinates.slice();
      var description = e.features[0].properties.description;

      // 確保訊息視窗不會被遮擋
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      // 設定訊息視窗內容並在地圖上顯示
      popup.setLngLat(coordinates)
          .setHTML(description)
          .addTo(map);
    });     
    
    //設定地圖標記點
    var markerEl = document.createElement('img');
    markerEl.src = '../images/marker.png'; // 請代換為您的圖檔之 URL (例如 "https://example.com/image.png")
    markerEl.style = 'width:80px;';

    //建立地圖標記點
    map.on('load', function () {
      var nowMapCenterPoint = map.getCenter();
      map.addImage('marker', markerEl);//加入圖
      map.addLayer(pointsSource); //加入訊息框的layer
    });  
    
  } //mapMarker(myLatLng, map, infoWindow, mapInfo) { 

  //週邊環境
  // mapAround(myLatLng, map, infoWindow, service) {
  mapAround(center, map) {
    
    const box          = $('#locationSearch');
    const locationBtn  = box.find('#locationBtn');
    const classTabs    = box.find('.classTabs button');
    const distanceTabs = box.find('.distanceTabs button');
    const la           = box.find('.place');
    let distance       = 0;
    let place          = '';
    let markers        = [];
    var markerPopup    = [];

    box.find('.classTabs li').on('click', (h) => {
      // console.log(h.currentTarget.innerHTML);
      
    });

    //標記
    
    let createMarkers = (pm) => {
      
      // let placeLoc = pm.geometry.location;
      /*
      let marker = new google.maps.Marker({
        map     : map,
        position: placeLoc
      });
      */      
      /*
      原本註解
      marker.setIcon({
        url:'bank.png',
        size: new google.maps.Size(70, 71),
        anchor: new google.maps.Point(17, 14),
        scaledSize: new google.maps.Size(35, 35)
      });
      */
     /*
      marker.setMap(map);

      //計算兩點之間距離
      let meters = google.maps.geometry.spherical.computeDistanceBetween(myLatLng, placeLoc);

      //輸出地點(列表式)
      la.append('<li><p class="name">' + pm.name + '</p><p class="distance">約<span>' + Math.round(meters) + '</span>公尺</p></li>');

      //資訊窗
      let infoDOM = '<p class="name">' + pm.name + '</p>';
      google.maps.event.addListener(marker, 'click', function() {
        map.panTo(placeLoc);
        //infoWindow.setContent(pm.name);
        infoWindow.setContent(infoDOM);
        infoWindow.open(map, this);
      });

      markers.push(marker);
      */
    }
    

    //搜索標記 & 選擇地點
    // let publicMarkers = (myLatLng) => {
      let publicMarkers = (center) => { 
        
        //週邊環境移除
        // console.log('開始移除');
        // if(map.getLayer("nearby_amenity-style")) {
          // map.removeLayer("nearby_amenity-style");
          // map.removeSource("nearby_amenity"); //清除資料陣列
        // }
        
      
      /*
      let request = {
        location: myLatLng,
        radius  : distance,
        type    : place
      };
      let placeLatLng = [];
      let placeName   = [];
      
      service.nearbySearch(request, function(results, status) {
        if (status == google.maps.places.PlacesServiceStatus.OK) {
          clearMarkers();
          for (let i = 0; i < results.length; i++) {
            createMarkers(results[i]);
            placeLatLng.push(results[i].geometry.location);
            placeName.push(results[i].name);
          }
          //選擇地點
          la.find('li').each((i, e) => {
            $(e).on('click', () => {
              la.find('li').removeClass('active');
              $(e).addClass('active');
              map.panTo(placeLatLng[i]);
              infoWindow.setContent(placeName[i]);
              infoWindow.open(map, markers[i]);
            });
          });
        }else{
          clearMarkers();
          if (results.length == 0) {
            la.append('<li class="disabled">尚無相關資訊</li>');
          }
        }
      });
      */
      
    }
    
    
    //列表開啟 & 關閉
    locationBtn.on('click', () => {
      // console.log('開啟周邊設施選單');
      box.toggleClass('active');
      // console.log('結束周邊設施選單');
    });
    
    //類型切換
    classTabs.each((i, e) => {
      // console.log(e);
      if(i == 0){
        //預設順序第一個選取
        $(e).addClass('actives');
        place = $(e).data('type');
      }
      
      $(e).on('click', () => {
        // console.log(e);
        // classTabs.removeClass('actives');
        // $(e).addClass('actives');
        // place = $(e).data('type');
        if( $(e).attr('class') == 'actives' ) {
          //同筆開關
          classTabs.removeClass('actives');
        } else {
          //切換他筆
          classTabs.removeClass('actives');
          $(e).addClass('actives');
          place = $(e).data('type');
        }

      });
      
    });
    
    //方圓距離切換
    distanceTabs.each((i, e) => {
      if(i == 0){
        $(e).addClass('actives');
        distance = $(e).data('distance');
      }
      $(e).on('click', () => {
        
        if( $(e).attr('class') == 'actives' ) {
          //同筆開關
          distanceTabs.removeClass('actives');
        } else {
          //切換他筆
          distanceTabs.removeClass('actives');
          $(e).addClass('actives');
        }
        /*
        distanceTabs.removeClass('actives');
        $(e).addClass('actives');
        /*/
        // distance = $(e).data('distance');
        // publicMarkers(myLatLng);
      });

    });

    //預設輸出
    // publicMarkers(myLatLng);
    
   
  } //mapAround(center, map) {

    
  //輸出
  mapAPI() {
    //這段只有一開始會進來
    //AJAX 匯入
    if(this.rd.length > 0){
      $.ajax({
        type: "POST",
        url : 'map.php',
        data: {
          nav: this.nav, //昀寬多加
          mt : this.mt,
          id : this.id
        },
        success: (mapData) => {
          //加入DOM
          this.rd.append(mapData);
          // $('.map8').html(mapData);
          // $('.map8').html('333');

          const map = $(this.map);
          const mapInfo = {
            el    : this.map,
            lat   : map.data('lat'),
            lng   : map.data('lng'),
            title : map.data('title'),
            add   : map.data('add'),
            option: map.data('option')
          };
          // $('.map8').html('222');
          //將物件放在中心點
          this.initialize(mapInfo);
        }
      });
    }
  }
}




//地圖找屋
class MapRealtySearch {

  constructor() {

    // this.markerclusterer = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js';
    
    //台灣圖霸api key
    this.gompAccessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM';
    
    this.mapBox          = $('#mapSearch');
    this.map             = '#mapCanvasSearch';
    this.loading         = $('#loadingMapData');

    this.headerEl    = $('header');
    this.containerEl = $('#container');
    this.locationEl  = this.containerEl.find('#location');
    this.pageTitleEl = this.containerEl.find('.pageTitle');

    this.mapTools     = $('#mapTools');
    this.lineDrawBtn  = this.mapTools.find('#lineDrawBtn'); //訂閱畫線按鈕
    this.objsListBtn  = this.mapTools.find('#objsListBtn');
    this.searchMapBtn = this.mapTools.find('#searchMapBtn');
    this.backBtn      = this.mapTools.find('#backBtn');

    this.locationSearch = $('#locationSearch');
    this.toggleBox      = this.locationSearch.find('.toggleBox');
    this.loadingObjs    = $('#loadingObjsData'); 
    this.lineDrawData   = this.toggleBox.find('#lineDrawData'); //畫線說明內容
    this.ajaxObjsList   = this.toggleBox.find('.ajaxObjsList'); //物件列表
    this.mapSearchForm  = $('#mapSearchForm'); //搜尋物件條件
    this.submitMapBtn   = this.mapSearchForm.find('#submitMapBtn'); //搜尋按鈕
    this.subscriptionBtn = this.mapSearchForm.find('#subscriptionBtn');//訂閱按鈕

    this.lineDrawDataBtn = this.lineDrawData.find('.btn'); //地圖圈選按鈕
    this.mapLineDrawDistance = this.mapSearchForm.find('.mapLineDrawDistance'); //選圈選距離
    // console.log(this.submitMapBtn);

    //偏移距離
    this.boundsRange = {
        // lat: 0.013, 
        // lng: 0.022
        lat: 0.0003, 
        lng: 0.0001
    }

  }

  //自適應高度
  rwdHeight() {
    let resultH = 0;
    let windowH = $(window).height();
    if(window.matchMedia('(min-width: 1280px)').matches){
      this.locationEl.show();
      this.pageTitleEl.show();
      resultH = windowH - this.headerEl.outerHeight() - (this.locationEl.outerHeight() + this.pageTitleEl.outerHeight());
    }else{
      this.locationEl.hide();
      this.pageTitleEl.hide();
      resultH = windowH - this.headerEl.outerHeight();
    }
    this.mapBox.css('height', resultH);
  }

  //全螢幕
  fullscreenMap() {
    this.locationEl.css({
      maxWidth: '100%',
      margin  : 0
    });
    this.pageTitleEl.find('.box').css({
      maxWidth: '100%',
      margin  : 0
    });
    this.containerEl.find('.area').css({
      maxWidth: '100%',
      margin  : 0
    });
    this.rwdHeight(); //自適應高度
    $(window).on('resize', () => {
      this.rwdHeight();
    });
  }

  //列表 & 搜尋切換
  locationSearchToggle() {
    //列表 & 搜尋 (含 RWD)
    let resizeToggle = () => {
      //清空前一次事件
      this.lineDrawBtn.off('click'); //關閉地圖圈訂閱
      this.objsListBtn.off('click');
      this.searchMapBtn.off('click');

      if(window.matchMedia('(max-width: 1279px)').matches){

        if(this.locationSearch.is('.active')){

          /*
          if(this.toggleBox.is('.active')){
            //開搜尋條件
            this.searchMapBtn.addClass('active'); //open
            this.objsListBtn.removeClass('active'); //close
            this.lineDrawBtn.removeClass('active'); //close
          }else{
            
            //開列表
            this.objsListBtn.addClass('active'); //open
            this.searchMapBtn.removeClass('active'); //close
            this.lineDrawBtn.removeClass('active'); //close
          }
          */
        }else{
          //全關
          this.objsListBtn.removeClass('active'); //close
          this.searchMapBtn.removeClass('active'); //close
          this.lineDrawBtn.removeClass('active'); //close
          this.toggleBox.removeClass('active2');
        } // if(this.locationSearch.is('.active')){
        

        //列表
        this.objsListBtn.on('click', (e) => {
          const $this = $(e.currentTarget);
          $this.toggleClass('active');
          this.searchMapBtn.removeClass('active');
          this.lineDrawData.removeClass('active'); 
          // this.toggleBox.removeClass('active');
          this.toggleBox.removeClass('active2');
          this.toggleBox.addClass('active');
          
          if($this.is('.active')){
            this.locationSearch.addClass('active');
          }else{
            this.locationSearch.removeClass('active');
          }
        });
        //搜尋
        this.searchMapBtn.on('click', (e) => {
          const $this = $(e.currentTarget);
          $this.toggleClass('active');
          this.objsListBtn.removeClass('active');
          this.lineDrawData.removeClass('active');
          this.toggleBox.addClass('active2');

          if($this.is('.active')){
            this.locationSearch.addClass('active');
          }else{
            this.locationSearch.removeClass('active');
          }
        });
        //畫圖訂閱
        this.lineDrawBtn.on('click', (e) => {

          const $this = $(e.currentTarget);
          $this.toggleClass('active');

          //將其它已打開的選項關閉
          this.objsListBtn.removeClass('active');
          this.searchMapBtn.removeClass('active');
          this.toggleBox.removeClass('active');
          this.toggleBox.removeClass('active2');

          if($this.is('.active')){
            this.locationSearch.addClass('active');
          }else{
            this.locationSearch.removeClass('active');
          }
          // console.log(this.lineDrawData);

          // if($this.is('.active')){
          //   this.lineDrawData.addClass('active');
          // }else{
          //   this.lineDrawData.removeClass('active');
          // }
        });
      }else{
        this.objsListBtn.addClass('active');
        this.searchMapBtn.removeClass('active');
        this.locationSearch.removeClass('active');
        this.toggleBox.removeClass('active');

        //列表
        this.objsListBtn.on('click', (e) => {
          const $this = $(e.currentTarget);
          $this.addClass('active');
          this.searchMapBtn.removeClass('active');
          this.locationSearch.addClass('active');
          this.toggleBox.removeClass('active');
        });
        //搜尋
        this.searchMapBtn.on('click', (e) => {
          const $this = $(e.currentTarget);
          $this.addClass('active');
          this.objsListBtn.removeClass('active');
          this.locationSearch.addClass('active');
          this.toggleBox.addClass('active');
        });
        //畫圖訂閱
        this.lineDrawBtn.on('click', (e) => {
          /*
          const $this = $(e.currentTarget);
          $this.addClass('active');
          this.objsListBtn.removeClass('active');
          this.locationSearch.addClass('active');
          this.toggleBox.addClass('active');
          */
          const $this = $(e.currentTarget);
          $this.toggleClass('active');

          //將其它已打開的選項關閉
          this.objsListBtn.removeClass('active');
          this.searchMapBtn.removeClass('active');
          this.toggleBox.removeClass('active');

          // console.log(this.lineDrawData);

          // if($this.is('.active')){
          //   this.lineDrawData.addClass('active');
          // }else{
          //   this.lineDrawData.removeClass('active');
          // }
        });
      }

      //畫面關閉按鈕
      // this.objsListBtn_close = $('#objsListBtn_close');
      this.objsListBtn_close = $('.objsListBtn_close');

      //列表關閉
      this.objsListBtn_close.on('click', (e) => {
        $('#locationSearch').removeClass('active'); //畫布上層
        $('.toggleBox').removeClass('active'); //搜尋畫布
        $('.toggleBox').removeClass('active2');
        $('#searchMapBtn').removeClass('active'); //搜尋條件
        $('#objsListBtn').removeClass('active'); //物件列表
        $('#lineDrawBtn').removeClass('active'); //訂閱
      });

      //按下訂閱按鈕全關(到地圖圈選)
      /*
      this.lineDrawDataBtn.on('click', (e) => {
        $('#locationSearch').removeClass('active'); //畫布上層
        $('.toggleBox').removeClass('active'); //搜尋畫布
        $('.toggleBox').removeClass('active2');
        $('#searchMapBtn').removeClass('active'); //搜尋條件
        $('#objsListBtn').removeClass('active'); //物件列表
        $('#lineDrawBtn').removeClass('active'); //訂閱

        //改變滑鼠手勢
        console.log(this.map);
        // this.map.getCanvas().style.cursor = 'crosshair';
        // this.map.style.cursor = 'crosshair';
        // this.mapBox.css("cursor","crosshair");

        //先將地圖上的物件移除
        var draw = new gompDraw({
            displayControlsDefault: false,
            controls: {
                polygon: true,
                trash: true
            }
        });
        
        map.addControl(draw);

        // clickDistance();

      }); //this.lineDrawDataBtn.on('click', (e) => {
    */

      /* ****** 建立中央點並畫圈 start ****** */
    
      // let clickDistance = () => {
        // map.getCanvas().style.cursor = 'crosshair';
        // map.on('click', function(e) {
          // console.log('測試');
        // });
      // } //clickDistance() {

      
      /* ****** 建立中央點並畫圈 end ****** */

      //按下距離全關
      this.mapLineDrawDistance.on('click', (e) => {

        $('#locationSearch').removeClass('active'); //畫布上層
        $('.toggleBox').removeClass('active'); //搜尋畫布
        $('.toggleBox').removeClass('active2');
        $('#searchMapBtn').removeClass('active'); //搜尋條件
        $('#objsListBtn').removeClass('active'); //物件列表
        $('#lineDrawBtn').removeClass('active'); //訂閱

      }); //this.mapLineDrawDistance.on('click', (e) => {
      
    } // let resizeToggle = () => {

    resizeToggle();
    $(window).on('resize', resizeToggle);

    //送出搜尋返回列表
    this.submitMapBtn.on('click', () => {
      this.toggleBox.removeClass('active');

      if(window.matchMedia('(max-width: 1279px)').matches){
        this.locationSearch.removeClass('active');
        this.lineDrawBtn.removeClass('active'); //關閉畫圖訂閱
      }else{
        this.objsListBtn.addClass('active');
        this.searchMapBtn.removeClass('active');
        this.lineDrawBtn.removeClass('active'); //關閉畫圖訂閱
      }
    });
  }
  //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)
  locationSearchBack() {
    if(window.matchMedia('(max-width: 1279px)').matches){
      this.locationSearch.removeClass('active');
      this.toggleBox.removeClass('active');
      this.searchMapBtn.removeClass('active');
      this.objsListBtn.removeClass('active');
      this.lineDrawBtn.removeClass('active'); //關閉畫圖訂閱
    }
  } //locationSearchBack() {

  //重整資訊，弄成適合map8的陣列資料
  markerInfoWindow(jsonArray) {
    let content = ""; //訊息內容參數
    let typePrice = 0;

    //資料庫引入物件資料
    let objLat    = jsonArray.lat;
    let objLng    = jsonArray.lng;
    let objId     = jsonArray.object_info_id;
    let objTitle  = jsonArray.case_name;
    let objType   = jsonArray.commission_model;
    let objClass  = jsonArray.land_name;
    let add       = jsonArray.outer_address;
    let floor     = jsonArray.t_floor;
    let floorB    = jsonArray.r_floor;
    let room      = jsonArray.room_nums;
    let livingR   = jsonArray.living_room_nums;
    let wc        = jsonArray.bathroom_nums;
    let age       = jsonArray.c_date;
    let imgFolder = jsonArray.object_img_folder;
    let imgName   = jsonArray.img_name;
    let price     = parseInt(jsonArray.co_price).toFixed(0);
    let rent      = parseInt(jsonArray.c_rent).toFixed(0);
    let rentM     = jsonArray.c_rent_month;

    //---製作視窗內容 start
    
    // content += "<div style='cursor: pointer;' onclick=window.open('?nav=buy_d&id="+objId+"')>";
    content += "<div style='cursor: pointer;' onclick=window.open('?nav=all_object_d&id="+objId+"')>";
    //案名
    content += "<h3 style='color:#008ed8;font-size: 1rem;font-weight: 700;margin:0 0 5px 0;'>"+objTitle+"</h3>";
    //外部地址
    content += "<p style='color: #555;margin:0  0 3px 0;line-height: 1.25rem;'>"+add+"</p>";

    //建物類型、地坪
    content += "<p style='color: #555;margin:0 0 3px 0;line-height: 1.25rem;'>";
    content += "<font style='color:#008ed8;font-weight:bold;'>"+objClass+"</font> ";
    content += "| 地坪 : <font style='color:#008ed8;font-weight:bold;'>"+floorB+"</font> 坪</p>";

    //格局(房廳衛、屋齡)
    if(objClass == '建地' || objClass == '農地' || objClass == '工業地' || objClass == '土地(其他)') {
        content += "";
    } else {
        content += "<p style='color: #555;margin:0 0 3px 0;line-height: 1.25rem;'>";
        content += "格局 : <font style='color:#008ed8;font-weight:bold'>"+room+"</font> 房 ";
        content +=  "<font style='color:#008ed8;font-weight:bold'>"+livingR+"</font> 廳 ";
        content += "<font style='color:#008ed8;font-weight:bold'>"+wc+"</font> 衛 ";
        content += "| 屋齡 : <font style='color:#008ed8;font-weight:bold'>"+age+"</font> 年";
        content += "</p>";
    }
    //價格(區分租金、買價)
    if(objType == '售案' || objType == '租售案') {
        content += "<p style='color: #555;margin:0 0 3px 0;line-height: 1.25rem;'>總價 : <font style='color:red;font-weight:bold;'>"+ price +" 萬</p>";
        typePrice = price;
    }
    if(objType == '租案' || objType == '租售案') {
        content += "<p style='color: #555;margin:0 0 3px 0;line-height: 1.25rem;'>租金 : <font style='color:red;font-weight:bold;'>"+rent+"元 / "+rentM+" 個月</p>";
        typePrice = rent;
    }

    content += "<br><img src='https://singfujia.s3.hicloud.net.tw/item/object/more_large/"+imgFolder+"/"+imgName+"' style='width:150px;'>";
    content += "</div>";

    //傳送數據
    let feature = {
      'type' : 'Feature',
      'geometry' : {
          'type' : 'point',
          'coordinates' : [objLng, objLat]
      },
      'properties' : {
          "name" :  objTitle,
          "cost" :  typePrice,
          "description" :  content,
          "image-url" : "https://singfujia.s3.hicloud.net.tw/item/object/more_large/"+imgFolder+"/"+imgName,
      }

      
    };

    return feature;
  } //markerInfoWindow() {

  //自動定位到目前的位置，並檢查瀏覽器是否支援定位服務
  //因 HTML5 navigator.geolocation 與 Google Map 不支援ES6， 所以採用 ES5 寫法
  positioning(map, myLatLng) {
    let option = {
      enableHighAccuracy: true,
      timeout           : 60000,
      maximumAge        : 0
    };
    let userLocation;
    let $gpsBtn = $('#gpsBtn');

    //隱藏 GPS 按鈕
    $gpsBtn.parent().hide();

    //判斷是否支援定位服務
    if(navigator.geolocation){
      // alert('啟動定位');
      //取得使用者現在座標位置並顯示
      // console.log('進入1');
      navigator.geolocation.getCurrentPosition(displayAndWatch, errorCallback, option);
    }else{
      // alert('預設定位');
      // console.log('進入2');
      //回到預設座標
      map.panTo(myLatLng);
      // alert('您目前的設備不支援定位服務');
      Swal.fire('您目前的設備不支援定位服務');
    }

    //GPS錯誤訊息
    function errorCallback(error) {
      let errorTypes = {
        0: '不明原因錯誤',
        //1: '使用者拒絕提供位置資訊',
        1: 'GPS定位服務尚未開啟\n開啟後請再重整瀏覽器',
        2: '無法取得位置資訊',
        3: '位置查詢逾時'
      };
      //let errorMessage = 'error code=' + error.code + '\n' + error.message + '\n' + errorTypes[error.code];
      let errorMessage = errorTypes[error.code];
      // alert(errorMessage);
      Swal.fire(errorMessage);
    }

    //回原點 & RWD
    function backPoint(pos) {
      //取得座標
      // let getLocation = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);

      //回原點
      $('#backBtn').on('click', function() {
        //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)
        if(window.matchMedia('(max-width: 1279px)').matches){
          $('#locationSearch').removeClass('active');
          $('.toggleBox').removeClass('active');
          $('#searchMapBtn').removeClass('active');
          $('#objsListBtn').removeClass('active');
        }
        map.panTo(getLocation);
      });
      //RWD
      /*
      google.maps.event.clearInstanceListeners(window);
      google.maps.event.addDomListener(window, 'resize', () => {
        google.maps.event.trigger(map, 'resize');
        map.panTo(getLocation);
      });
      */
    }

    function displayAndWatch(position) {
      //定位目前使用者座標位置
      setUserLocation(position);
      //判斷行動裝置，是否開啟 & 關閉監聽使用者座標位置是否移動 (GPS模式)
      if(checkDevice.ios || checkDevice.android){
        watchCurrentPosition();
      }
      //回原點 & RWD
      backPoint(position);
    }

    //定位目前使用者座標位置
    function setUserLocation(pos) {

      //地圖縮放
      map.setZoom(17);
      //取得座標
      // let getLocation = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
      //顯示標記
      const markerSize = 80;
      /*
      userLocation = new google.maps.Marker({
        position: getLocation,
        map     : map,
        icon    : {
          url       : 'images/marker0.png',
          scaledSize: new google.maps.Size(markerSize, markerSize),
          origin    : new google.maps.Point(0, 0),
          anchor    : new google.maps.Point(markerSize / 2, markerSize / 2)
        },
      });
      */
      function location() {
        map.panTo(getLocation);
      }
      location();
      /*
      google.maps.event.addListener(userLocation, 'click', function() {
        location();
      });
      */
    }

    //開啟 & 關閉監聽使用者座標位置是否移動 (GPS模式)
    function watchCurrentPosition() {
      let positionTimer;
      $gpsBtn.parent().show();
      $gpsBtn.off('click').on('click', function() {
        // console.log('222');
        $(this).toggleClass('active');
        if($(this).is('.active')){
          positionTimer = navigator.geolocation.watchPosition(function(position) {
            //定位移動過後使用者座標位置
            setMarkerPosition(userLocation, position);
            // map.panTo(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
            //回原點 & RWD
            backPoint(position);
            //console.log(position)
          });
        }else{
          navigator.geolocation.clearWatch(positionTimer);
        }
      });
      //搜尋送出後，停止GPS模式
      $('#submitMapBtn').on('click', function() {
        $gpsBtn.removeClass('active');
        navigator.geolocation.clearWatch(positionTimer);
      });
    }

    //定位移動後使用者座標位置
    function setMarkerPosition(marker, position) {
    //  marker.setPosition(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
    //  console.log(position);
    }
  }

  //Google Map 地理編碼城市文字回傳坐標，城市有資料時則進入重新定位
  // getCity(map, geocoder) {
  getCity(map) {  
    let city    = this.mapSearchForm.find('input[name=city]:checked').val(); //縣市
    
    let area    = this.mapSearchForm.find('input[name=area]:checked').val(); //區域
    let areaRecord = this.mapSearchForm.find('.areaClass').val(); //訂閱-區域
    let areaValue = ''; //送出區域內容

    let keyword = this.mapSearchForm.find('input[name=map_keyword_value]').val(); //關鍵字
    let latlngData = '';

    let zoomValue = 12;
    if(keyword != '') {
      //關鍵字有值拉近
      zoomValue = 15;
    }

    let codeAdd = (cityArea) => {
     
      //https://api.map8.zone/place/geocode/json?
      //https://api.map8.zone/v2/place/geocode/json?key=
      $.ajax({
        url: "https://api.map8.zone/v2/place/geocode/json?key=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM&address="+cityArea,
        context: document.body,
        async: false
      }).done(function(results) {
        $( this ).addClass( "done" );
        latlngData = results.results[0].geometry.location;
        // map.panTo(results.results[0].geometry.location);
        map.flyTo({
          center: results.results[0].geometry.location, // 中心點
          zoom: zoomValue, // 縮放比例
          // pitch: 45 // 頃斜度
        })
      });

    } //let codeAdd = (cityArea) => {

    let backPoint = (txt) => {
      //回原點
      this.backBtn.off('click').on('click', () => {
        //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)
        this.locationSearchBack();
        codeAdd(txt);
      });
    }

    //判斷區
    if(typeof area === 'undefined') {
      if(typeof areaRecord === 'undefined') {
        areaRecord = '';
      } else {
        areaValue = areaRecord;
      }
    } else {
      areaValue = area;
    }

    if(city != undefined){
      if(areaValue == ''){
        if(city == '金門縣' || city == '澎湖縣') {
          codeAdd(city);
          backPoint(city);
        } else {
          codeAdd(city.replace(/市/, "")+'火車站');
          backPoint(city.replace(/市/, "")+'火車站');
        }
      }else{
        // codeAdd(city + area+'衛生所');
        // backPoint(city + area+'衛生所');
        codeAdd(city + areaValue);
        backPoint(city + areaValue);
      }
    }
    //'S'為物件編號
    if(keyword != '' && keyword.indexOf('S') == -1 && keyword.indexOf('s') == -1){  
      //console.log('丟台灣圖霸');
      //非搜尋物件編號
      codeAdd(keyword);
      backPoint(keyword);
    }
    /*
    if(keyword != '' && (keyword.indexOf('S') == 0 || keyword.indexOf('s') == 0) ){  
      console.log('丟公司資料庫');

      //非搜尋物件編號
      // codeAdd(keyword);
      // backPoint(keyword);
    }
    */
    return latlngData; //回傳中心點
  } //getCity(map) {  
  
  //AJAX連接資料庫引入物件資料(行為：初始，搜尋輸入框未輸入編號)
  // ajaxAllObjSearch(map, infoWindow, markerClusterer) {
  ajaxAllObjSearch(map, mapInfo) {  
    // console.log('ajaxAllObjSearch進入');
    //引入資料變數
    let markerList = [];
    let markers    = [];
    // console.log(map.getLayer('pois'));
    
    let ajaxSQL = () => {
      //Loading 開啟
      this.loading.addClass('active');
      let ajaxFile = 'ajax_map_search.php';
      let formData = this.mapSearchForm.serializeArray();
      
      //取得畫面範圍座標
      let bounds = map.getBounds();
      let sw     = bounds.getSouthWest();
      let ne     = bounds.getNorthEast();
      let swLat  = sw.lat;
      let swLng  = sw.lng;
      let neLat  = ne.lat;
      let neLng  = ne.lng;
   
      //判斷官網與業務版
      let personalId = $('#personalIdVal').val();

      //Ajax 連結 MySQL 資料庫 (地圖 Google Map 地點標記僅引入 json 格式)
      //Ajax 連結 MySQL 資料庫 (此部份列表已完善，map8更新坐標需製作)
      // console.log('執行撈全部資料');

      $.post(ajaxFile, {
        type       : 'all',
        sw_Lat     : swLat,
        sw_Lng     : swLng,
        ne_Lat     : neLat,
        ne_Lng     : neLng,
        // personal_id: personalId,
        dataType   : 'json',
        contentType: 'application/json; charset=UTF-8',
        data  : JSON.stringify(formData)
      }, (json) => {
        //搜尋完的資料陣列
        // console.log('進到全列資料');
        // console.log(json);

        //去掉因Null出現的空白
        json = json.replace(/\u0000/g, '').replace(/\\u0000/g, "");
        json = JSON.parse(json); //編譯為json


        //要用在map8的陣列
        var arrayMap8Data = {
          'type'      : 'FeatureCollection',
          'features'  : new Array()
        };

        //Loading 關閉
        this.loading.removeClass('active');

        //載入資料庫物件資料
        for(let index in json){

          //資料庫引入物件資料
          // console.log(this.boundsRange.lat);
          json[index].lat = json[index].lat - this.boundsRange.lat;
          json[index].lng = json[index].lng - this.boundsRange.lng;
          let objLat    = json[index].lat;
          let objLng    = json[index].lng;

          //核對經緯度是否有重覆的物件，如有就跳過 (增加效能用)
          let isInList = (lat, lng) => {
            for(let i in markerList){
              if(markerList[i].t == lat && markerList[i].g == lng){
                return true;
              }
            }
            return false;
          }
          
          if(isInList(objLat, objLng)){
            continue;
          } 

          //加入標記 & 資訊窗(使用帶出的json資料，代入map8圖層，將資料整理成適合map8的json格式)
          let feature = this.markerInfoWindow(json[index]);

          //將已點擊的圖標變為紅色

          //加到主陣列
          arrayMap8Data['features'].push(feature);
          
          //---製作視窗內容 end
        } //for(let index in json){

          // console.log(arrayMap8Data);
        //更新地圖上坐標資料
       
        // markerClusterer.setGridSize(mcOptions.gridSize);
        // markerClusterer.setMaxZoom(mcOptions.maxZoom);
        // markerClusterer.setStyles(mcOptions.styles);
        // markerClusterer.addMarkers(markers);
        // console.log(arrayMap8Data); 
        // console.log('二次');
        // var searchList = '';

        // 移除地圖相關數據
        // if(map.getLayer('clusters')) {
        //   map.removeLayer('clusters');//移除群組最大點
        // }
        // if(map.getLayer('cluster-count')) {
        //   map.removeLayer('cluster-count'); //移除群組數字
        // }
        // if(map.getLayer('pois')) {
        //   map.removeLayer('pois'); //移除最小坐標點
        // }
        // map.removeSource('housesale'); //移除舊的數據資料陣列
        
        //更新地圖數據
        if(map.getSource('housesale')) { 
          map.getSource('housesale').setData(arrayMap8Data);
        }
        
      // }, 'json');
      });
      
      // --- (右側物件列表)
      //Ajax 連結 MySQL 資料庫 (右側物件列表)
      let objList = (nowPage) => {
        //Loading 開啟
        this.loadingObjs.addClass('active');
        
        $.post(ajaxFile, { 
          type       : 'allList',
          sw_Lat     : swLat,
          sw_Lng     : swLng,
          ne_Lat     : neLat,
          ne_Lng     : neLng,
          personal_id: personalId,
          data       : JSON.stringify(formData),
          nowPage    : nowPage
        }, (data) => {
          // console.log(data);

          //Loading 關閉
          this.loadingObjs.removeClass('active');

          //刪除原先物件列表
          this.ajaxObjsList.empty();
          //加入物件列表
          this.ajaxObjsList.append(data);
          //圖片延遲載入並裁切
          let lazyLoad = new LazyLoad;
          lazyLoad.scrollImgLoad();
          //頁碼點擊後換頁、引入下一筆資料
          this.toggleBox.find('.pagination a').each((i, e) => {
            $(e).on('click', () => {
              objList($(e).data('page'));
            });
          });

          //畫面關閉按鈕
          // this.objsListBtn_close = $('#objsListBtn_close');
          this.objsListBtn_close = $('.objsListBtn_close');

          //列表關閉
          this.objsListBtn_close.on('click', (e) => {
            $('#locationSearch').removeClass('active');
            $('#lineDrawData').removeClass('active'); //關閉畫線說明內容
            $('.toggleBox').removeClass('active');
            $('#searchMapBtn').removeClass('active');
            $('#objsListBtn').removeClass('active');
          });

        });
      } //let objList = (nowPage) => {
      objList();
    } //let ajaxSQL = () => {

    //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)
    let locationSearchBack = () => {
      this.locationSearchBack();
    }

    //載入前先標記清空(含集合)
    let markerClear = () => {
      if(markers.length > 0){
        for(var i = 0; i < markers.length; i++){
          if(markers[i]){
            markers[i].setMap(null); //標記清空
          }
        }
        markerList = [];
        markers    = [];
      }
    }

    //加入事件並引入資料顯示標記
    let mapupdater;
    
    //無任何動作
    map.on('load', function() {
    // $(document).on('load', () => {
    // console.log(map);
    
    // map.load( () => {  
      mapupdater = setTimeout(ajaxSQL, 500);

      //視窗拖曳事件 start
      map.on('dragstart', () => {
          mapupdater = setTimeout(ajaxSQL, 500);
      });

      //視窗放大縮小 start
      map.on('zoomstart', () => {
          mapupdater = setTimeout(ajaxSQL, 500);
      });
      
    }); //map.on('load', function() {
    
    

  } //ajaxAllObjSearch(map, mapInfo) { 
      
  //AJAX連接資料庫引入物件資料(行為：搜尋輸入框已輸入編號)
  ajaxOnlyObjSearch(map, infoWindow) {
    //Loading 開啟
    this.loading.addClass('active');
    this.loadingObjs.removeClass('active');

    let ajaxFile = 'ajax_map_search.php';
    let formData = this.mapSearchForm.serializeArray();
    
    //引入資料變數
    let markerList = [];

    //判斷官網與業務版
    let personalId = $('#personalIdVal').val();

    //Ajax 連結 MySQL 資料庫 (地圖 Google Map 地點標記僅引入 json 格式)
    $.post(ajaxFile, {
      type       : 'only',
      dataType   : 'json',
      contentType: 'application/json; charset=UTF-8',
      // personal_id: personalId,
      data       : JSON.stringify(formData)
    }, (json) => {
    // },function(json) {  

      //去掉因Null出現的空白
      json = json.replace(/\u0000/g, '').replace(/\\u0000/g, "");
      json = JSON.parse(json); //編譯為json


      //要用在map8的陣列
      var arrayMap8Data = {
        'type'      : 'FeatureCollection',
        'features'  : new Array()
      };

      //Loading 關閉
      this.loading.removeClass('active');

      // console.log(json2);
      //載入資料庫物件資料
      for(let index in json){
        
        //資料庫引入物件資料
        // console.log(this.boundsRange.lat);
        let objLat    = json[index].lat -this.boundsRange.lat;
        let objLng    = json[index].lng -this.boundsRange.lng;

        //核對經緯度是否有重覆的物件，如有就跳過 (增加效能用)
        let isInList = (lat, lng) => {
          for(let i in markerList){
            if(markerList[i].t == lat && markerList[i].g == lng){
              return true
            }
          }
          return false
        }
        if(isInList(objLat, objLng)){
          continue;
        }

        //加入標記 & 資訊窗(使用帶出的json資料，代入map8圖層，將資料整理成適合map8的json格式)
        let feature = this.markerInfoWindow(json[index]);

        //加到主陣列
        arrayMap8Data['features'].push(feature);

        //更新地圖上的數據
        map.on('load', function(){
          if(map.getSource('housesale')) { 
            map.getSource('housesale').setData(arrayMap8Data);
          } //if(map.getSource('housesale')) { 
        });  

        // console.log(arrayMap8Data);

        //中心點移置到該物件
        map.flyTo({
          center: [objLng, objLat], // 中心點
          zoom: 15, // 縮放比例 
          // pitch: 45 // 頃斜度
        })

        //回原點
        this.backBtn.off('click').on('click', () => {
          //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)
          this.locationSearchBack();
          // map.panTo(objLatLng);
          map.flyTo({
            center: [objLng, objLat], // 中心點
            zoom: 15, // 縮放比例
            // pitch: 45 // 頃斜度
          })
        });
        

        //加入已核對陣列
        /*
        markerList.push({
          t: objLat,
          g: objLng
        });
        */

        //RWD
        /*
        google.maps.event.clearInstanceListeners(window);
        google.maps.event.addDomListener(window, 'resize', () => {
          google.maps.event.trigger(map, 'resize');
          map.panTo(objLatLng);
        });
        */
      } //for end
    // }, 'json');
    });

    //Ajax 連結 MySQL 資料庫 (右側物件列表)
    $.post(ajaxFile, {
      type       : 'onlyList',
      personal_id: personalId,
      data       : JSON.stringify(formData)
    }, (data) => {
      //console.log(data);

      //Loading 關閉
      this.loadingObjs.removeClass('active');

      //刪除原先物件列表
      this.ajaxObjsList.empty();
      //加入物件列表
      this.ajaxObjsList.append(data);
      //圖片延遲載入並裁切
      let lazyLoad = new LazyLoad;
      lazyLoad.scrollImgLoad();

      //畫面關閉按鈕
      // this.objsListBtn_close = $('#objsListBtn_close');
      this.objsListBtn_close = $('.objsListBtn_close');

      //列表關閉
      this.objsListBtn_close.on('click', (e) => {
        $('#locationSearch').removeClass('active');
        $('#lineDrawData').removeClass('active'); //關閉畫線說明內容
        $('.toggleBox').removeClass('active');
        $('#searchMapBtn').removeClass('active');
        $('#objsListBtn').removeClass('active');
      });

    });

  } //ajaxOnlyObjSearch(map, infoWindow) {


  /* **************** 學區圖處理 start ************/
  /*
  schoolDist(map) {
    var schoolDistType = ["school_district_es", "school_district_jhs"];
    map.once("idle", function() {
        map.addSource("school_dist", {
            type: "vector",
            url: "https://api.map8.zone/data/school-district.json"
        });
        schoolDistType.forEach(function(name, i) {
            map.addLayer({
                'id': name,
                'type': "fill",
                'source': "school_dist",
                'source-layer': name,
                'paint': {

                    'fill-color': '#000000',
                    'fill-opacity': 0.7
                },
                'layout': {
                    'visibility': 'none'
                }
            });
            map.addLayer({
                'id': name + '_line_black',
                'type': "line",
                'source': "school_dist",
                'source-layer': name,
                'paint': {
                    'line-color': (name == 'school_district_es') ? '#666' : '#333',
                    'line-opacity': 1,
                    'line-width': 0.5
                },
                'layout': {
                    'line-join': 'miter',
                    'visibility': 'none'
                }
            });
            map.addLayer({
                'id': name + '_line',
                'type': "line",
                'source': "school_dist",
                'source-layer': name,
                'paint': {
                    'line-color': (name == 'school_district_es') ? '#ffff00' : '#ff6f00',
                    'line-opacity': 1,
                    'line-width': 3
                },
                'layout': {
                    'line-join': 'miter',
                    'visibility': 'none'
                }
            }, name + '_line_black');
            map.addLayer({
                'id': name + '_text',
                'type': "symbol",
                'source': "school_dist",
                'source-layer': name,
                'layout': {
                    'text-field': [
                        'format',
                        ['get', 'schoolname'], {},
                        '\n ', {},
                        '學區', {'font-scale': .8},
                    ],
                    'text-font': ["Open Sans Bold"],
                    'text-size': 15,
                    'visibility': 'none'
                },
                'paint': {
                    'text-color': (name == 'school_district_es') ? '#ffff00' : '#fc7c21',
                    'text-halo-color': '#000',
                    'text-halo-width': 1
                }
            });
        }); 
    });

    //--學區線 css 設定
    var schoolDistOptions = {
      'school_district_es': {
          'common_fill-color': '#C2C200', 
          'common_fill-opacity': 0.3,
          'common_text-color': '#333',
          'common_text-halo-color': '#fff',
          'highlight_fill-color': '#C2C200',
          'highlight_fill-opacity': 0.4,
          'highlight_text-color': '#ffff00',
          'highlight_text-halo-color': '#000',//文字
          'highlightSchool': [''],
          'darkLineColor': '#C2C200',
          'lightLineColor': '#ffff00'
      },
      'school_district_jhs': {
          'common_fill-color': '#ff6f00',
          'common_fill-opacity': 0.15,
          'common_text-color': '#333',
          'common_text-halo-color': '#fff',
          'highlight_fill-color': '#ff6f00',
          'highlight_fill-opacity': 0.5,
          'highlight_text-color': '#ff6f00',
          'highlight_text-halo-color': '#000',//文字
          'highlightSchool': [''],
          'darkLineColor': '#ff6f00',
          'lightLineColor': '#ff6f00'
      }
    } //var schoolDistOptions = {
    
    //畫圖線
    let setSchoolDistLayerVisibility = (schoolDistType, visibility) => { 
      var layerNameSuffixes = ['', '_line', '_line_black', '_text'];
      layerNameSuffixes.forEach(function(v) {
          map.setLayoutProperty(schoolDistType + v, "visibility", visibility);
      });
    } //let setSchoolDistLayerVisibility = (schoolDistType, visibility) => {

    //判斷學區圖
    let toggleSchoolDistLayers = (target) => { 
      // console.log('進到toggleSchoolDistLayers');
      if (target == schoolDistType[0]) {
          setSchoolDistLayerVisibility(schoolDistType[0], 'visible');
          setSchoolDistLayerVisibility(schoolDistType[1], 'none');
      } else if (target == schoolDistType[1]) {
          setSchoolDistLayerVisibility(schoolDistType[0], 'none');
          setSchoolDistLayerVisibility(schoolDistType[1], 'visible');
      } else {
          //不顯示
          setSchoolDistLayerVisibility(schoolDistType[0], 'none');
          setSchoolDistLayerVisibility(schoolDistType[1], 'none');
      }
    } //let toggleSchoolDistLayers= (target) => { 
  } //schoolDist(map) {
    */
    /* **************** 學區圖處理 end ************/

  //整合 & API 導入繪製地圖
  initialize(mapInfo, mapZoom) {
  // initialize(mapInfo) {  
    this.loading.addClass('active'); //一開始讀取就打開loading畫面

    const lat = mapInfo.lat;
    const lng = mapInfo.lng;
    const myLatLng = [ lng, lat ];
    var boundsRange = {
      lat: 0.013, 
      lng: 0.022
    }
    // console.log(mapInfo.lat);
    // console.log(mapInfo.lng);
    
    //台灣圖霸api key
    gomp.accessToken = this.gompAccessToken;
    // console.log('地圖找房');
    //地圖基本設定
    var mapOptions = {
      container: 'mapCanvasSearch', // 地圖容器 ID
      // style: 'https://api.map8.zone/styles/go-life-maps-tw-style-std/style.json', // 地圖樣式檔案位置
      style: 'https://api.map8.zone/styles/go-life-maps-tw-style-singfujia-0e0150b5/style.json',
      maxBounds: [[105, 15], [138.45858, 33.4]], // 台灣地圖區域
      // maxBounds: [[center.lng - boundsRange.lng, center.lat - boundsRange.lat], [center.lng + boundsRange.lng, center.lat + boundsRange.lat]],
      center: [lng, lat], // 初始中心座標，格式為 [lng, lat]
      // center: [120.221420, 23.008305], // 初始中心座標，格式為 [lng, lat]
      zoom: 15, // 初始 ZOOM LEVEL; [0-20, 0 為最小 (遠), 20 ;最大 (近)]
      // zoom: mapZoom, // 初始 ZOOM LEVEL; [0-20, 0 為最小 (遠), 20 ;最大 (近)]
      minZoom: 6, // 限制地圖可縮放之最小等級, 可省略, [0-19.99]
      maxZoom: 19.99, // 限制地圖可縮放之最大等級, 可省略 [0-19.99]
      pitch: 0, // 攝影機仰角, 可省略, [0-60]
      bearing: 0, // 地圖角度, 可省略, [-180 ~ 180; 0 為正北朝上, 180 為正南朝上]
      attributionControl: false,
      speedLoad: false
    };

    //全螢幕(先偵測畫面大小並放置適合大小)
    this.fullscreenMap();
    
    //繪製地圖
    var map = new gomp.Map(mapOptions).addControl(new gomp.AttributionControl({
      compact: false
    }));

    // map.addControl(new gomp.NavigationControl(), 'top-left'); //週邊地圖拉遠拉進設定加入

    //列表 & 搜尋切換
    this.locationSearchToggle();

    //設定地圖標記點
    var markerEl = document.createElement('img');
    markerEl.src = './images/marker.png'; // 請代換為您的圖檔之 URL (例如 "https://example.com/image.png")
    markerEl.style = 'width:80px;';

    map.on('click', 'pois', function(e) {
        // 設定滑鼠游標樣式
        map.getCanvas().style.cursor = 'pointer';

        var coordinates = e.features[0].geometry.coordinates.slice();
        var description = e.features[0].properties.description;

        // 確保訊息視窗不會被遮擋
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }
    });

    // this.schoolDist(map); //學區圖處理



    /****** 學區圖 start *******/
    var schoolDistType = ["school_district_es", "school_district_jhs"];
    map.once("idle", function() {
        map.addSource("school_dist", {
            type: "vector",
            url: "https://api.map8.zone/data/school-district.json"
        });
        schoolDistType.forEach(function(name, i) {
            map.addLayer({
                'id': name,
                'type': "fill",
                'source': "school_dist",
                'source-layer': name,
                'paint': {

                    'fill-color': '#000000',
                    'fill-opacity': 0.7
                },
                'layout': {
                    'visibility': 'none'
                }
            });
            map.addLayer({
                'id': name + '_line_black',
                'type': "line",
                'source': "school_dist",
                'source-layer': name,
                'paint': {
                    'line-color': (name == 'school_district_es') ? '#666' : '#333',
                    'line-opacity': 1,
                    'line-width': 0.5
                },
                'layout': {
                    'line-join': 'miter',
                    'visibility': 'none'
                }
            });
            map.addLayer({
                'id': name + '_line',
                'type': "line",
                'source': "school_dist",
                'source-layer': name,
                'paint': {
                    'line-color': (name == 'school_district_es') ? '#ffff00' : '#ff6f00',
                    'line-opacity': 1,
                    'line-width': 3
                },
                'layout': {
                    'line-join': 'miter',
                    'visibility': 'none'
                }
            }, name + '_line_black');
            map.addLayer({
                'id': name + '_text',
                'type': "symbol",
                'source': "school_dist",
                'source-layer': name,
                'layout': {
                    'text-field': [
                        'format',
                        ['get', 'schoolname'], {},
                        '\n ', {},
                        '學區', {'font-scale': .8},
                    ],
                    'text-font': ["Open Sans Bold"],
                    'text-size': 15,
                    'visibility': 'none'
                },
                'paint': {
                    'text-color': (name == 'school_district_es') ? '#ffff00' : '#fc7c21',
                    'text-halo-color': '#000',
                    'text-halo-width': 1
                }
            });
        }); 
    });

    //--學區線 css 設定
    /*
    var schoolDistOptions = {
      'school_district_es': {
          'common_fill-color': '#C2C200', 
          'common_fill-opacity': 0.3,
          'common_text-color': '#333',
          'common_text-halo-color': '#fff',
          'highlight_fill-color': '#C2C200',
          'highlight_fill-opacity': 0.4,
          'highlight_text-color': '#ffff00',
          'highlight_text-halo-color': '#000',//文字
          'highlightSchool': [''],
          'darkLineColor': '#C2C200',
          'lightLineColor': '#ffff00'
      },
      'school_district_jhs': {
          'common_fill-color': '#ff6f00',
          'common_fill-opacity': 0.15,
          'common_text-color': '#333',
          'common_text-halo-color': '#fff',
          'highlight_fill-color': '#ff6f00',
          'highlight_fill-opacity': 0.5,
          'highlight_text-color': '#ff6f00',
          'highlight_text-halo-color': '#000',//文字
          'highlightSchool': [''],
          'darkLineColor': '#ff6f00',
          'lightLineColor': '#ff6f00'
      }
    } //var schoolDistOptions = {
    */
    //畫圖線
    let setSchoolDistLayerVisibility = (schoolDistType, visibility) => { 
      var layerNameSuffixes = ['', '_line', '_line_black', '_text'];
      layerNameSuffixes.forEach(function(v) {
          map.setLayoutProperty(schoolDistType + v, "visibility", visibility);
      });
    } //let setSchoolDistLayerVisibility = (schoolDistType, visibility) => {

    //判斷學區圖
    let toggleSchoolDistLayers = (target) => {
      // console.log('進到toggleSchoolDistLayers');
      if (target == schoolDistType[0]) {
          setSchoolDistLayerVisibility(schoolDistType[0], 'visible');
          setSchoolDistLayerVisibility(schoolDistType[1], 'none');
      } else if (target == schoolDistType[1]) {
          setSchoolDistLayerVisibility(schoolDistType[0], 'none');
          setSchoolDistLayerVisibility(schoolDistType[1], 'visible');
      } else {
          //不顯示
          setSchoolDistLayerVisibility(schoolDistType[0], 'none');
          setSchoolDistLayerVisibility(schoolDistType[1], 'none');
      }
    } //let toggleSchoolDistLayers = (target) => { 
    /******學區圖 end ********/
    
    
   

    /********設定畫圖圈選設定 start ********/
    
  
    /*
    var draw = new gompDraw({
        displayControlsDefault: false,
        controls: {
            polygon: true, //多邊形
            trash: true
        }
    });
    
    map.addControl(draw);

    var coordinateContainer = document.getElementById('coordindate');

    map.on('draw.create', updateArea);
    map.on('draw.delete', updateArea);
    map.on('draw.update', updateArea);

    
    // updateArea() {
    let updateArea = (e) => { 
        var data = draw.getAll();
        coordinateContainer.innerHTML = '';
        if (data.features.length > 0) {
            data.features.forEach(function(feature) {
                feature.geometry.coordinates[0].forEach(function(coordinate) {
                    coordinateContainer.innerHTML += '[' + coordinate.join(', ') + '] (' + Math.round(map.project(coordinate).x) + ', ' + Math.round(map.project(coordinate).y) + ')<br />';
                    // console.log( Math.round(map.project(coordinate).x) + '::' +  Math.round(map.project(coordinate).y) );
                    // console.log(e);

                });
            });
        }
    }
    */

    /********設定畫圖控制 end ********/

    /*** 判斷一開始進頁面，自動畫圈的判斷 start */

    let drawDistanceValue = (distanceValue, distance_lng, distance_lat) => {
      
      //畫圈
      let radiusValue = distanceValue/1000; //抓資料範圍
      let colorIndex = {blue: "#2970C0", green: "#4E9A54", gold: "#D28706", red: "#D63030"};

      let popup = new gomp.Popup({
        anchor: 'bottom',
        closeButton: true,
        closeOnClick: false,
        autoPan: true,
        offset: [0, -42],
        className: 'my-class'
      });
    
      
      //---把值放入到map8地圖

      // 繪製中心點半徑方圓範圍
      // var circle = turf.circle(turf.point([mapInfo.lng, mapInfo.lat]), radius / 1000, {});
      let circle = turf.circle(turf.point([distance_lng, distance_lat]), radiusValue, {});
      
      //先讓地圖加載完，再戴入style
      map.on('load', function() {
        map.addLayer({
            "id": "circle-fill",
            "type": "fill",
            "source": {
                "type": "geojson",
                "data": circle
            },
            "paint": {
                "fill-color": colorIndex["blue"],
                "fill-opacity": 0.2
            }
        });

        map.addLayer(
            {
                id: "circle-text",
                type: "symbol",
                source: {
                    type: "geojson",
                    data: {
                        type: "FeatureCollection",
                        features: [
                            {
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: [distance_lng, distance_lat]
                                }
                            }
                        ]
                    }
                },
                layout: {
                    'text-allow-overlap': true,
                    'text-field': '半徑 '+ distanceValue +' 公尺範圍',
                    'text-font': ["Open Sans Regular"],
                    'text-offset': [0, 1],
                    'text-size': 15
                },
                paint: {
                    'text-color': colorIndex["blue"],
                    'text-halo-color': '#fff',
                    'text-halo-width': 2
                }
            }
        );

        //圓圈外框線
        map.addLayer({
            "id": "circle-outline",
            "type": "line",
            "source": {
                "type": "geojson",
                "data": circle
            },
            "paint": {
                "line-color": "blue",
                "line-opacity": 0.3,
                "line-width": 2,
                "line-offset": 1
            },
            "layout": {
            }
        });

        //中心點移置到該範圍
        map.setCenter([distance_lng, distance_lat]); //移動中心點
        map.setZoom(13); //縮放

      }); // map.on('load', function() {
        

    } //let drawDistanceValue = (distanceValue, distance_lng, distance_lat) => {

    //一開始加載，確認是否有資料
    let distanceRadio_val = $('.search_distance_none').find('input[name=distanceRadio]:checked').val();
    let distance_lng = $('#distance_lng').val();  
    let distance_lat = $('#distance_lat').val();

    if(distanceRadio_val && distance_lng && distance_lat ) {
      drawDistanceValue(distanceRadio_val, distance_lng, distance_lat); //執行進function
    }
    
    /*** 判斷一開始進頁面，自動畫圈的判斷 end */

    /******* 設定圈選按鈕 strt ****** */

    //按下訂閱按鈕全關(到地圖圈選)
    /*
    $('#lineDrawData').find('button').each((i, e) => {
      $(e).on('click', () => {  

        //關閉選單
        $('#locationSearch').removeClass('active'); //畫布上層
        $('.toggleBox').removeClass('active'); //搜尋畫布
        $('.toggleBox').removeClass('active2');
        $('#searchMapBtn').removeClass('active'); //搜尋條件
        $('#objsListBtn').removeClass('active'); //物件列表
        $('#lineDrawBtn').removeClass('active'); //訂閱

        // 移除地圖上的物件資料
        map.getSource('housesale').setData({ 'type': 'FeatureCollection', 'features': [] });

        // 移除畫圖資料
        if( map.getLayer("circle-outline") ) {  
    
          map.removeLayer("circle-outline");  //外圍線
          map.removeSource("circle-outline"); //清除資料陣列
  
          map.removeLayer("circle-text"); //字
          map.removeSource("circle-text"); //清除資料陣列
  
          map.removeLayer("circle-fill"); //底色
          map.removeSource("circle-fill"); //清除資料陣列
  
        } //if( map.getLayer("circle-outline") ) {  
    
        //改變滑鼠手勢
        map.getCanvas().style.cursor = 'crosshair';

        //範圍指定給參數
        distanceValue = $(e).data('value'); 

        //開啟畫地圖圈選
        mouseStatus = true;

      }); //$(e).on('click', () => {  
    });  //$('#lineDrawData').find('button').each((i, e) => {
    */

    let distanceValue = 500; //範圍, 預設500
    var mouseStatus = false; //切換圈選方式，預設開啟
    $('.fa-xmark').hide(); //預設把X關起來
    $('#drawRound_div').hide(); //預設按鈕不顯示

    $('#drawRound').on('click', (e) => {

        //打開X，關掉O
        $('.fa-xmark').show(); 
        $('.fa-o').hide(); 

        // 移除地圖上的物件資料
        map.getSource('housesale').setData({ 'type': 'FeatureCollection', 'features': [] });

        
        // 移除畫圖資料
        if( map.getLayer("circle-outline") ) {  
    
            map.removeLayer("circle-outline");  //外圍線
            map.removeSource("circle-outline"); //清除資料陣列
    
            map.removeLayer("circle-text"); //字
            map.removeSource("circle-text"); //清除資料陣列
    
            map.removeLayer("circle-fill"); //底色
            map.removeSource("circle-fill"); //清除資料陣列

        } //if( map.getLayer("circle-outline") ) {  
        
        //改變滑鼠手勢
        map.getCanvas().style.cursor = 'crosshair';

        //範圍指定給參數
        // distanceValue = $(e).data('value'); 
        distanceValue = 1000;

        //開啟畫地圖圈選
        mouseStatus = true;

    }); //$('#drawRound').on('click', () => {
    


    //按下條件搜尋的距離(搜尋bar關)
    $('.mapLineDrawDistance').find('button').each((i, e) => {
      $(e).on('click', () => {  

        //開啟icon範圍button
        $('#drawRound_div').show(); //按鈕開啟

        //關閉選單
        $('#locationSearch').removeClass('active'); //畫布上層
        $('.toggleBox').removeClass('active'); //搜尋畫布
        $('.toggleBox').removeClass('active2');
        $('#searchMapBtn').removeClass('active'); //搜尋條件
        $('#objsListBtn').removeClass('active'); //物件列表
        $('#lineDrawBtn').removeClass('active'); //訂閱

        // 移除地圖上的物件資料
        map.getSource('housesale').setData({ 'type': 'FeatureCollection', 'features': [] });

        // 移除畫圖資料
        if( map.getLayer("circle-outline") ) {  
    
            map.removeLayer("circle-outline");  //外圍線
            map.removeSource("circle-outline"); //清除資料陣列
    
            map.removeLayer("circle-text"); //字
            map.removeSource("circle-text"); //清除資料陣列
    
            map.removeLayer("circle-fill"); //底色
            map.removeSource("circle-fill"); //清除資料陣列
  
        } //if( map.getLayer("circle-outline") ) {  
    
        //改變滑鼠手勢
        map.getCanvas().style.cursor = 'crosshair';

        //範圍指定給參數
        distanceValue = $(e).data('value'); 

        //開啟畫地圖圈選
        mouseStatus = true;

      }); //$(e).on('click', () => {  
    });  //$('#lineDrawData').find('button').each((i, e) => {


    map.on('mousedown', (f) => {  

        //打開X，關掉O
        $('.fa-xmark').hide(); 
        $('.fa-o').show(); 

      //點擊地圖 start

      //先判斷是否為連續畫圈
      
      if(mouseStatus == false) {
        return false;
      } //if(mouseStatus == false) {

      // drawDistanceValue(distanceValue, f.lngLat.lng, f.lngLat.lat); //執行進function

      //畫圈
      var radiusValue = distanceValue/1000; //抓資料範圍
      var colorIndex = {blue: "#2970C0", green: "#4E9A54", gold: "#D28706", red: "#D63030"};

      var popup = new gomp.Popup({
        anchor: 'bottom',
        closeButton: true,
        closeOnClick: false,
        autoPan: true,
        offset: [0, -42],
        className: 'my-class'
      });
      

      //---把值放入到map8地圖

      // 繪製中心點半徑方圓範圍
      // var circle = turf.circle(turf.point([mapInfo.lng, mapInfo.lat]), radius / 1000, {});
      var circle = turf.circle(turf.point([f.lngLat.lng, f.lngLat.lat]), radiusValue, {});
      
      map.addLayer({
          "id": "circle-fill",
          "type": "fill",
          "source": {
              "type": "geojson",
              "data": circle
          },
          "paint": {
              "fill-color": colorIndex["blue"],
              "fill-opacity": 0.2
          }
      });
      
      map.addLayer(
          {
              id: "circle-text",
              type: "symbol",
              source: {
                  type: "geojson",
                  data: {
                      type: "FeatureCollection",
                      features: [
                          {
                              type: "Feature",
                              geometry: {
                                  type: "Point",
                                  coordinates: [f.lngLat.lng, f.lngLat.lat]
                              }
                          }
                      ]
                  }
              },
              layout: {
                  'text-allow-overlap': true,
                  'text-field': '半徑 '+ distanceValue +' 公尺範圍',
                  'text-font': ["Open Sans Regular"],
                  'text-offset': [0, 1],
                  'text-size': 15
              },
              paint: {
                  'text-color': colorIndex["blue"],
                  'text-halo-color': '#fff',
                  'text-halo-width': 2
              }
          }
      );

      //圓圈外框線
      map.addLayer({
          "id": "circle-outline",
          "type": "line",
          "source": {
              "type": "geojson",
              "data": circle
          },
          "paint": {
              "line-color": "blue",
              "line-opacity": 0.3,
              "line-width": 2,
              "line-offset": 1
          },
          "layout": {
          }
      });

      //中心點移置到該範圍
      map.setCenter([f.lngLat.lng,f.lngLat.lat]); //移動中心點
      map.setZoom(13); //縮放

      // 將圈內的物件資料列出，因使用紀有的搜尋，呼叫this.ajaxAllObjSearch，因此在此將範圍跟中心點丟進form裡去搜尋
      $('#distance_lat').val(f.lngLat.lat);
      $('#distance_lng').val(f.lngLat.lng);

      $('input[name=distanceRadio]').attr('checked', false); //先將選取的全取消
      $('input[name=distanceRadio]').each(function() {
        
        if( $(this).val() == distanceValue) {
          // console.log($(this).val() );
          // $(this).attr('checked', 'checked'); //範圍數字一致時，就選取起來
          $(this).attr('checked', true); //範圍數字一致時，就選取起來
        } else {
          $(this).attr('checked', false);
        }

      });
      
      //搜尋bar的按鈕做選取
      $('.mapLineDrawDistance').find('button').removeClass('select_radio_button'); //先將選取的全取消
      $('.mapLineDrawDistance').find('button').each(function() {
        if( $(this).val() == distanceValue) {
          $(this).addClass('select_radio_button'); //範圍數字一致時，就選取起來
        } else {
          $(this).removeClass('select_radio_button'); //不一致則取消
        }
      });

      //滑鼠還原成手指
      map.getCanvas().style.cursor = 'pointer';

      //關閉畫圖
      mouseStatus = false;

      //列出圈選區塊物件
      let ajaxFile = 'ajax_map_search.php'; //呼叫資料路徑

      //取得畫面範圍座標
      //引入資料變數
      let markerList = [];
      let markers    = [];
      // console.log('更新地圖物件開始');
      // console.log('distance_value' + ':');

      $.post(ajaxFile, {
        'type'           : 'distance',
        'center_lat'     : f.lngLat.lat,
        'center_lng'     : f.lngLat.lng,
        'distance_value' : distanceValue
      }, (json) => {
        //搜尋完的資料陣列
        // console.log('ajax出來數據');
        // console.log(json);

        //要用在map8的陣列
        
        var arrayMap8Data = {
          'type'      : 'FeatureCollection',
          'features'  : new Array()
        };

        //Loading 關閉
        this.loading.removeClass('active');

        //載入資料庫物件資料
        for(let index in json){

          //資料庫引入物件資料
          let objLat    = json[index].lat;
          let objLng    = json[index].lng;

          //核對經緯度是否有重覆的物件，如有就跳過 (增加效能用)
          let isInList = (lat, lng) => {

            for(let i in markerList){
              if(markerList[i].t == lat && markerList[i].g == lng){
                return true
              }
            }
            return false;
          }
          
          if(isInList(objLat, objLng)){
            continue;
          } 

          //加入標記 & 資訊窗(使用帶出的json資料，代入map8圖層，將資料整理成適合map8的json格式)
          let feature = this.markerInfoWindow(json[index]);

          //將已點擊的圖標變為紅色

          //加到主陣列
          arrayMap8Data['features'].push(feature);
          
          //---製作視窗內容 end
        } //for(let index in json){

        // console.log(arrayMap8Data);
        
        //更新地圖數據
        if(map.getSource('housesale')) { 
          map.getSource('housesale').setData(arrayMap8Data);
        }

        //用完清空
        let markerClear = () => {
          if(markers.length > 0){
            for(var i = 0; i < markers.length; i++){
              if(markers[i]){
                markers[i].setMap(null); //標記清空
              }
            }
            markerList = [];
            markers    = [];
          }
        }
        
        
      }, 'json'); //$.post(ajaxFile, {
      

      // //更新地圖數據
      // if(map.getSource('housesale')) { 
      //   map.getSource('housesale').setData(arrayMap8Data);
      // }



      //觸發搜尋(地圖更新)
      
      // el  : map,
      // let mapInfo = {
      //   el  : "#mapCanvasSearch",
      //   zoom: 14,
      //   lat : f.lngLat.lat,
      //   lng : f.lngLat.lng
      // };
      // this.initialize(mapInfo, mapInfo.zoom);

      // console.log(mapInfo);
      
      // this.ajaxAllObjSearch({map, mapInfo});

    }); //map.on('mousedown', (f) => {  
   

    /* ****** 設定圈選按鈕 end ****** */

    /*** 清空 範圍條件 start **/
    //重置(因有連點的問題，加上unbind取消綁定點擊避免出現連點)
    $('.reSelect').unbind('click').on('click', () => {  
      
        // 移除選按鈕的icon button 
        $('#drawRound_div').hide(); 
        
        // 移除畫圖資料
        if( map.getLayer("circle-outline") ) {  
    
            map.removeLayer("circle-outline");  //外圍線
            map.removeSource("circle-outline"); //清除資料陣列
    
            map.removeLayer("circle-text"); //字
            map.removeSource("circle-text"); //清除資料陣列
    
            map.removeLayer("circle-fill"); //底色
            map.removeSource("circle-fill"); //清除資料陣列
    
        } //if( map.getLayer("circle-outline") ) {  
         
        $('input[name=distanceRadio]').attr('checked', false); //先將選取的全取消   
        $('.mapLineDrawDistance').find('button').removeClass('select_radio_button'); //先將選取的全取消

        $('input[name="distanceRadio"]:checked').prop('checked', false);//清除距離
        $('.mapLineDrawDistance').find('button').removeClass('select_radio_button'); //消除距離選取的class
        //清除中心點
        $('#distance_lat').val('');
        $('#distance_lng').val('');

        //移除其它欄位的資料
        $('#map_keyword_value').val(''); //清空搜尋bar
        $('#map_keyword_value').val(''); //清空搜尋bar

        //城市選擇移除
        $('.box .city').find('span').html('縣市區域');//改縣市title
        $('input[name=city]').prop('checked', false); //移除區//移除市
        $('input[name=area]').prop('checked', false); //移除區
        $('.searchCancel').html(' '); //移除區
        
        //物件類型回到預設狀態
        // $('#tbClassesAll').trigger("click");
        $('.classificationClass').prop('checked', false); //checkbox 全取消
        $('#tbClassesAll').trigger("click"); //物件類型不限觸發
        $('.class').find('span').html('類型不限'); //類型不限狀態

        //總價回到預設狀態
        $('.priceClass').prop('checked', false); //checkbox 全取消
        $('.price input[type=tel').val(''); //清掉輸入框
        $('#tbPriceAll').trigger("click"); //總價不限觸發
        $('.price').find('span').html('總價不限'); //總價不限狀態

        //建坪回到預設狀態
        $('.floorClass').prop('checked', false); //checkbox 全取消
        $('.floor input[type=tel').val(''); //清掉輸入框
        $('#tbFloorAll').trigger("click"); //建坪不限觸發
        $('.floor').find('span').html('建坪不限'); //建坪不限狀態

        //地坪回到預設狀態
        $('.floorLandClass').prop('checked', false); //checkbox 全取消
        $('.floorB input[type=tel').val(''); //清掉輸入框
        $('#tbFloorBAll').trigger("click"); //建坪不限觸發
        $('.floorB').find('span').html('地坪不限'); //建坪不限狀態

        //房數回到預設狀態
        $('.roomClass').prop('checked', false); //checkbox 全取消
        $('.room input[type=tel').val(''); //清掉輸入框
        $('#roomAll').trigger("click"); //房數不限觸發
        $('.room').find('span').html('房數不限'); //房數不限狀態

        //屋齡回到預設狀態
        $('.more_yearsClass').prop('checked', false); //checkbox 全取消
        $('.moreYears input[type=tel').val(''); //清掉輸入框
        $('#moreYearsAll').trigger("click"); //屋齡不限觸發
        $('.moreYears').find('span').html('屋齡不限'); //屋齡不限狀態

        //樓層回到預設狀態
        $('.more_fClass').prop('checked', false); //checkbox 全取消
        $('.moreF input[type=tel]').val(''); //清掉輸入框
        $('#moreFAll').trigger("click"); //樓層不限觸發
        $('.moreF').find('span').html('樓層不限'); //樓層不限狀態

        //車位回到預設不限
        $('.more_parkingClass').prop('checked', false); //checkbox 全取消
        $('#more_parking').trigger("click"); //車位不限觸發
        $('.moreParking').find('span').html('車位不限'); //車位不限

        //特色環境回到預設不限
        $('.more_featuresClass').prop('checked', false); //checkbox 全取消
        $('#moreFeaturesAll').trigger("click"); //環境不限觸發
        $('.moreFeatures').find('span').html('環境不限'); //環境不限

        //預售屋回到預設不限
        $('.more_keyWordSelectClass').prop('checked', false); //checkbox 全取消
        $('input[name=more_keyWordSelect]').prop('checked', false); //清除全選
        $('#moreKeyWordSelectAll').trigger("click"); //預售屋不限觸發
        $('.moreKeyWordSelect').find('span').html('預售屋不限'); //預售屋不限

        //按下重置，資料庫也清空
        let ajaxFile = 'ajax_map_subscription.php';
        $.post(ajaxFile, {
          'subscription_type': 3,
          'member_authCode'  : $('#member_authCode').val(),
          'formData'         : this.mapSearchForm.serializeArray()
        }, (json) => {
          //處理訂閱完成後回來的程式
          
          if(json === 'ok') {
            // alert('訂閱已重置');
            Swal.fire({
                title: '訂閱已重置',
                icon: 'success',
                confirmButtonText: '確定',
            }).then((result) => {
                if (result.isConfirmed) {
                    // location.reload();
                    // //重新跑搜尋
                    this.submitMapBtn.click();
                }
            });
            //重新跑搜尋
            // this.submitMapBtn.click();
            // location.href = '?nav=subscription_list';
          }
        }, 'json'); //$.post(ajaxFile, {

        //重新載入搜尋
        // this.initialize(mapInfo, mapInfo.zoom); //載入地圖

    });

    /*** 清空 範圍條件 end **/
    map.on('load', function() {
      //---頁面載入完會先進到此頁(訂閱 or 一般使用皆會使用，只要有呼叫 initialize 皆會跑到這邊。此處做群組集合使用)

      //---新增資料來源 (GeoJSON 格式) 並設定 cluster (群聚選項) 為 true(幸福家物件全部座標)      
      let formDataVal = $('#mapSearchForm').serializeArray();

      //抓取物件資料方便轉入housesale數據
      var houseSaleValue = '';
      $.ajax({
          type :"POST",
          url  : "ajax_map8Data.php",
          cache: false,
          async: false,
          data : { 'search_data': formDataVal },
          dataType: "json",
          success : function(data, textStatus) {
            // houseSaleValue = msg;
            houseSaleValue = data;
            // console.log(data);
          }
      });  
      
      
      map.addSource("housesale", {
          type: "geojson",
          data: houseSaleValue, // 此範例所使用的檔案請見
          // data: "ajax_map8Data.php", // 此範例所使用的檔案請見 https://www.map8.zone/js/vector/housesale.json
          cluster: true,
          clusterMaxZoom: 14, // 顯示群聚點的最大 zoom level
          clusterRadius: 50 // 設定群聚半徑 (單位公尺 / 預設 50)
      });

      //群組圓型圖css設定
      
      map.addLayer({
          id: "clusters",
          type: "circle",
          source: "housesale",
          filter: ["has", "point_count"],
          paint: {
              "circle-color": [
                  "step",
                  ["get", "point_count"],
                  // 數量小於 10 為黃褐色
                  "#D6D0B2",
                  10,
                  // 數量 10 - 50 為淡藍色
                  "#95B1E1",
                  // 數量 50 以上 為灰藍色
                  50,
                  "#838B98"
              ],
              "circle-radius": [
                  "step",
                  ["get", "point_count"],
                  20,
                  20,
                  30,
                  50,
                  40
              ]
          }
      });

      
      
      $(".school_district_class").click(function(){
      // $(".school_district_class").trigger("click", function(){  
        var iconValue     = $(this).attr('data-info'); //抓取學區圖的顯示狀態

        //判斷學區圖
        if( iconValue == 'school_district_es') {
          //國小
          toggleSchoolDistLayers('school_district_es');
        } else if( iconValue == 'school_district_jhs' ) {
          //國中
          toggleSchoolDistLayers('school_district_jhs');
        // } else if( iconValue == 'hideAll' ) {
        //   //不顯示學區
        //   toggleSchoolDistLayers('hideAll');
        } else {
          toggleSchoolDistLayers('hideAll');
        } //if( iconValue == 'school_district_es') {
          
        
        // MapAround(catValue, iconValue, distanceValue);
      }); //$(".school_district_class").trigger("click")(function(){  
      
      //群組數字
      map.addLayer({
          id: "cluster-count",
          type: "symbol",
          source: "housesale",
          filter: ["has", "point_count"],
          layout: {
              "text-field": "{point_count}",
              "text-size": 16,
              "text-font": ["Noto Sans Regular"]
          }
      });  

      //縮到最小坐標的設定
      map.addLayer({
          // id: "unclustered-point",
          // type: "circle",
          id: "pois",
          type: "symbol",
          source: "housesale",
          filter: ["!", ["has", "point_count"]],
          layout : {
              "icon-image": "marker",
              "icon-size": 0.25,
              "icon-offset": [0, -21],
              "icon-allow-overlap": true
          }
      });
      
      // 查看群聚點
      map.on('click', 'clusters', function (e) {
          var features = map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
          var clusterId = features[0].properties.cluster_id;
          map.getSource('housesale').getClusterExpansionZoom(clusterId, function (err, zoom) {
              if (err)
              return;
              map.easeTo({
                  center: features[0].geometry.coordinates,
                  zoom: zoom
              });
          });
      });
      
      //圖標加入自訂的icon
      map.addImage('marker', markerEl);

      map.on('mouseenter', 'clusters', function () {
          map.getCanvas().style.cursor = 'pointer';
      });
      map.on('mouseleave', 'clusters', function () {
          map.getCanvas().style.cursor = '';
      });
    }); //map.on('load', function(){
    
    
    //----全物件資料列出 end

    
    //------加入訊息視窗(點擊用)
    var popup = new gomp.Popup({
      anchor: 'bottom',
      closeButton: true,
      closeOnClick: false,
      offset: [0, -42],
      width: 300
    });

    //坐標點擊觸發程式
    map.on('click', 'pois', function(e) {
            
      // 設定滑鼠游標樣式
      map.getCanvas().style.cursor = 'pointer';

      var coordinates = e.features[0].geometry.coordinates.slice();
      var description = e.features[0].properties.description;

      // 確保訊息視窗不會被遮擋 
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      //e.lngLat.lng
      //e.lngLat.lat
      
      // 設定訊息視窗內容並在地圖上顯示
      popup.setLngLat(coordinates)
          .setHTML(description)
          .addTo(map);

      //點視窗，超過時移動地圖    
      var dPWidth = popup._container.offsetWidth; //視窗寬度
      // var dPHeight = popup._container.offsetHeight; //視窗高度
      var dPHeight = 400;
      var dPX = popup._pos.x;
      var dPY = popup._pos.y;
      var mapW = map.transform.width; //地圖寬度
      var mapH = map.transform.height; //地圖高度
      var padding = 20;
      var panPoint = {
          "x": 0,
          "y": 0
      }
      if (dPX < (dPWidth / 2 + padding)) {
          panPoint.x = dPX - ((dPWidth / 2) + padding);
      }
      if (dPX > (mapW - padding - (dPWidth / 2))) {
          panPoint.x = dPX - (mapW - (dPWidth / 2) - padding);
      }
      if (dPY < (dPHeight + padding)) {
          panPoint.y = dPY - (dPHeight + padding);
      }
      if (dPY > (mapH - padding)) {
          panPoint.y = dPY - (mapH - padding);
      }
      map.panBy([panPoint.x, panPoint.y]);

    }); //map.on('click', 'pois', function(e) {

    //回原點
    this.backBtn.off('click').on('click', () => {
      // alert('test');
      //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)
      // this.locationSearchBack();
      // map.panTo(myLatLng);
      
      var lng = mapInfo.lng;
      var lat = mapInfo.lat;
      // alert(lng+':'+lat);

      /*
      if ("geolocation" in navigator) {
        console.log(navigator.geolocation.getCurrentPosition);
      } else {
        alert("你的裝置或瀏覽器不支援定位功能");
      }
      */

      function successHandler(position) {

        // alert('同意定位');
        //同意定位
        lat = position.coords.latitude;
        lng = position.coords.longitude;

        map.flyTo({
          center: [lng, lat], // 中心點
          zoom: 15, // 縮放比例
          // pitch: 45 // 頃斜度
        })

      } //function successHandler(position) {
      
      function errorHandler(err) {
        // alert('沒有定位');
        //沒有定位或錯誤, 則訂位一開始的預設座標
        lat = mapInfo.lng;
        lng = mapInfo.lat;

        // alert(lat, lng);
        // var alert_msg = '定位錯誤，請進到手機設定看是否有開啟權限';
      
        // var alert_msg = '定位錯誤，請進到手機設定看是否有開啟權限\n\nandroid: 設定->位置->設定為開，點應用程式權限->找到幸福家不動產進入->選項改成 [僅在使用該應用程式時允許\n\nios: 設定 -> 幸福家不動產 -> 位置 -> 選擇 使用APP期間';
        var alert_msg = '定位錯誤，請進到手機設定看是否有開啟權限<br><br>android: 設定->位置->設定為開，點應用程式權限->找到幸福家不動產進入->選項改成 [僅在使用該應用程式時允許]。<br><br>ios: 設定 -> 幸福家不動產 -> 位置 -> 選擇 [使用APP期間]';
        // alert(alert_msg);
        Swal.fire(alert_msg);
      

        map.flyTo({
          center: [lng, lat], // 中心點
          zoom: 15, // 縮放比例
          // pitch: 45 // 頃斜度
        })
      } //function errorHandler(err) {

      //判斷是否有定位
      // alert('開始定位前');
      navigator.geolocation.getCurrentPosition(successHandler,  errorHandler);
      
      /*
      console.log('決定地點:');
      console.log(lat+','+lng);
      map.flyTo({
        center: [lng, lat], // 中心點
        zoom: 15, // 縮放比例
        // pitch: 45 // 頃斜度
      })
      */
    }); //this.backBtn.off('click').on('click', () => {
    
    
    //城市定位
    let latlngData = this.getCity(map); //部份城市有偏差
    // console.log('中心點:'+latlngData);
    // this.getCity(map);
    
    //搜尋輸入框已輸入數值，並判斷是否為'S'為物件編號，無為返回地理編碼模式(列表用資料處理)
    let keyword = this.mapSearchForm.find('input[name=map_keyword_value]').val();

    if(keyword != '' && keyword.indexOf('S') != -1 || keyword.indexOf('s') != -1){
      //AJAX連接資料庫引入物件資料(行為：搜尋輸入框已輸入編號)
      // this.ajaxOnlyObjSearch(map, infoWindow); //地圖obj、訊息框obj
      // console.log('找單一物件');
      this.ajaxOnlyObjSearch(map, mapInfo); //地圖obj、訊息框obj
    }else{
      //AJAX連接資料庫引入物件資料(行為：初始，搜尋輸入框未輸入編號)
      // console.log('找全部資料');
      this.ajaxAllObjSearch(map, mapInfo); //地圖obj、訊息框obj、API路徑(google 地圖坐標api)
      // this.ajaxAllObjSearch(map, infoWindow, markerClusterer); //地圖obj、訊息框obj、API路徑(google 地圖坐標api)
    } //if(keyword != '' && keyword.indexOf('S') != -1 || keyword.indexOf('s') != -1){

    //移除map8 logo
    $('.gomp-ctrl-bottom-right').remove();
    $('.gomp-ctrl-bottom-left').remove();

  } //initialize(mapInfo, mapZoom) {   

  //輸出(執行輸出地圖)
  mapAPI() {
    //預設台南火車站
    var lat = 22.99723350539961;
    var lng = 120.21316381063703;

    //總部(北門路)
    // var lat = 23.009148505419258;
    // var lng = 120.21585116219424;
   
    const mapInfo = {
      el  : this.map,
      zoom: 15,
      lat : lat,
      lng : lng
    };

    this.initialize(mapInfo, mapInfo.zoom); //載入地圖
    
    //搜尋送出重新載入地圖
    let submitMap = () => {

      //搜尋框Entern送出
      this.mapSearchForm.find('input[name=map_keyword_value]').bind('keypress', (e) => {

        if(e.keyCode==13){
          //重新載入地圖
          this.initialize(mapInfo, mapInfo.zoom);
        }

      });

      //搜尋按鈕送出
      this.submitMapBtn.on('click', () => {
        //重新載入地圖
        this.initialize(mapInfo, mapInfo.zoom);
      });

      //訂閱按鈕送出
      this.subscriptionBtn.on('click', () => {
        // location.href='?nav=subscription_list';
        let ajaxFile = 'ajax_map_subscription.php';

        //抓get的member_authcode值
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const value = urlParams.get('member_authcode');

        //用ajax跑訂閱資料儲存
        $.post(ajaxFile, {
          'subscription_type': 3,
          'member_authCode'  : $('#member_authCode').val(),
          'formData'         : this.mapSearchForm.serializeArray()
        }, (json) => {
          //處理訂閱完成後回來的程式
          if(json === 'ok') {
            // alert('訂閱已完成');
            Swal.fire({
                title: '訂閱已完成',
                confirmButtonText: '確定',
            }).then((result) => {
                if (result.isConfirmed) {
                    // location.reload();
                    // console.log(submitMap);
                    // this.submitMap.click(); //原本有 20230307 kai 註解
                    // submitMapBtnFunction.click();
                    // document.getElementById("submitMapBtn").click();
                    location.href='?nav=map_search&subscription_status=open&member_authcode='+value;
                }
            });

            // 跑搜尋
            // this.submitMapBtn.click(); //原本有 20230307 kai 註解
            // location.href = '?nav=subscription_list';
          }
        }, 'json'); //$.post(ajaxFile, {

      });
      
    } //let submitMap = () => {

    //移除map8 logo
    //$('.gomp-ctrl-bottom-right').remove();
    //$('.gomp-ctrl-bottom-left').remove();

    //搜尋送出
    submitMap();

    //判斷是否從地圖訂閱進頁面
    // this.mapScope();
    
  } //mapAPI() {


} //class MapRealtySearch {


//輸出
export {LightboxMap, MapRealtyDetail, MapRealtySearch}


// WEBPACK FOOTER //
// ./js_new/map.js